(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6973],{

/***/ 2439:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[id]",
      function () {
        return __webpack_require__(6814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/components/AppLayout/index.tsx + 43 modules
var AppLayout = __webpack_require__(1892);
// EXTERNAL MODULE: ./src/providers/BrazeProvider/index.tsx + 1 modules
var BrazeProvider = __webpack_require__(3590);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(2655);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(5735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(278);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-redux-virtual-d8cdb1e912/0/cache/react-redux-npm-8.0.4-ee216b0e53-fd940de6a6.zip/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(5703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(1975);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8749);
// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(6757);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/infinite/dist/index.mjs
var infinite_dist = __webpack_require__(8458);
// EXTERNAL MODULE: ./src/di-container/shop/detail/gateway/client.ts
var client = __webpack_require__(5627);
// EXTERNAL MODULE: ./src/di-container/construction-case/gateway/client.ts
var gateway_client = __webpack_require__(2307);
// EXTERNAL MODULE: ./src/di-container/common/scrap/gateway/client.ts
var scrap_gateway_client = __webpack_require__(1964);
// EXTERNAL MODULE: ./src/providers/ModalProvider/ModalProvider.tsx + 1 modules
var ModalProvider = __webpack_require__(2244);
// EXTERNAL MODULE: ./src/di-container/auth/gateway/client.ts
var auth_gateway_client = __webpack_require__(2885);
// EXTERNAL MODULE: ./src/providers/PopupProvider/PopupProvider.tsx + 1 modules
var PopupProvider = __webpack_require__(958);
// EXTERNAL MODULE: ./src/ui/ConstructionCaseCard/index.ts + 3 modules
var ConstructionCaseCard = __webpack_require__(7209);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(7046);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(7748);
// EXTERNAL MODULE: ./src/ui/Image/index.ts
var Image = __webpack_require__(1267);
// EXTERNAL MODULE: ./src/ui/BoardPagination/index.ts + 6 modules
var BoardPagination = __webpack_require__(5262);
;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/hooks/useConstruction.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var useConstruction = function(param) {
    var shopId = param.shopId, tabState = param.tabState;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var getKey = function() {
        var query = query_string.stringify({
            page: page,
            size: 30,
            shopId: String(shopId),
            exhibitHall: tabState,
            sort: "R",
            typeValue: "P"
        });
        return "construction_".concat(query);
    };
    var ref3 = (0,infinite_dist/* default */.ZP)(getKey, function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(query) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        _ctx.next = 3;
                        return (0,gateway_client/* constructionCaseGateway */.w)().getList.exec(query_string.parse(query));
                    case 3:
                        data = _ctx.sent;
                        setIsLoading(false); // API 요청이 완료되었을 때 isLoading을 false로 설정
                        return _ctx.abrupt("return", data);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }()), constructData = ref3.data;
    var constructList = (0,react.useMemo)(function() {
        if (constructData === null || constructData === void 0 ? void 0 : constructData[0].data) {
            var data = constructData[0].data;
            setIsLoading(false);
            return data;
        } else {
            return undefined;
        }
    }, [
        constructData
    ]);
    (0,react.useEffect)(function() {
        if (ref2) {
            var ref;
            (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0, 0);
        }
    }, [
        page
    ]);
    return {
        isLoading: isLoading,
        setPage: setPage,
        page: page,
        ref: ref2,
        constructList: constructList
    };
};
/* harmony default export */ var hooks_useConstruction = (useConstruction);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/ConstructionPopup.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  min-height: 558px;\n  height: 558px;\n  overflow: auto;\n  gap: 28px 20px;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding-left: 40px;\n  padding-right: 40px;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: sticky;\n  width: 100%;\n  justify-content: center;\n  height: 60px;\n  bottom: 0px;\n  background-color: ",
        ";\n  z-index: 999;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 558px;\n  display: flex;\n  padding-top: 20%;\n  justify-content: center;\n  /* align-items: center; */\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var ConstructionPopup = function(param) {
    var tabState = param.tabState, shopId = param.shopId;
    var ref = hooks_useConstruction({
        shopId: shopId,
        tabState: tabState
    }), constructList = ref.constructList, page = ref.page, setPage = ref.setPage, isLoading = ref.isLoading, ref1 = ref.ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: (0,utils/* getAsset */.Nh)("/assets/icons/loading-obj-new.gif"),
                    height: "40px",
                    width: "40px",
                    alt: "loadingIcon"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWrap, {
                ref: ref1,
                children: constructList === null || constructList === void 0 ? void 0 : constructList.content.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBox, {
                        width: "350px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstructionCaseCard/* default */.Z, {
                            item: item,
                            imgSize: {
                                width: "350px",
                                height: "197px"
                            }
                        })
                    }, "construct_list_".concat(item.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardPagination/* default */.Z, {
                    // TEMP
                    page: page,
                    handlePage: setPage,
                    totalPages: Number(constructList === null || constructList === void 0 ? void 0 : constructList.totalPages) || 1
                })
            })
        ]
    });
};
/* harmony default export */ var ui_ConstructionPopup = (ConstructionPopup);
var PopupWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ConstructionPopup__PopupWrap",
    componentId: "sc-ca6f1e9e-0"
})(_templateObject(), common/* CustomScroll */.c);
var CardBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ConstructionPopup__CardBox",
    componentId: "sc-ca6f1e9e-1"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
});
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ConstructionPopup__Footer",
    componentId: "sc-ca6f1e9e-2"
})(_templateObject2(), styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ConstructionPopup__Container",
    componentId: "sc-ca6f1e9e-3"
})(_templateObject3());
var LoadingBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ConstructionPopup__LoadingBox",
    componentId: "sc-ca6f1e9e-4"
})(_templateObject4());

// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(457);
// EXTERNAL MODULE: ./src/constants/shop.ts
var shop = __webpack_require__(2185);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-5c4b6f9b0e/0/cache/@design-system-pc-npm-4.9.1-beta.4-8219a2df4e-f8611c630d.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(784);
;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/hooks/useShopDetail.tsx
function useShopDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useShopDetail_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useShopDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useShopDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





















var useShopDetail = function(param) {
    var shopId = param.shopId;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(4), level = ref5[0], setLevel = ref5[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)({
        detailDataState: false,
        constructDataState: false
    }), isLoading = ref6[0], setIsLoading = ref6[1];
    var store = (0,es/* useStore */.oR)();
    var ref7 = (0,react.useState)(undefined), apartRankList = ref7[0], setApartRankList = ref7[1];
    var ref8 = (0,react.useState)(false), isScrap = ref8[0], setIsScrap = ref8[1];
    var ref9 = (0,react.useState)({
        code: "",
        name: "",
        index: 0
    }), tabState = ref9[0], setTabState = ref9[1];
    var ref10 = (0,react.useState)(false), isOpenConsultPopup = ref10[0], setIsOpenConsultPopup = ref10[1];
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    var ref11 = (0,scrap_gateway_client/* scrapGateway */.N)(), createScraps = ref11.createScraps, deleteScraps = ref11.deleteScraps;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var loginGateway = (0,auth_gateway_client/* authGateway */.h)(store.dispatch).loginGateway;
    var ref12 = (0,ModalProvider/* useModal */.d)(), modalOpen = ref12.handleOpen;
    var ref13 = (0,PopupProvider/* usePopup */.B)(), popupOpen = ref13.handleOpen;
    var toast = (0,design_system_pc/* useToast */.pm)().toast;
    var ref14 = (0,dist/* default */.ZP)({
        shopId: shopId
    }, function() {
        return (0,client/* shopDetailGateway */.f)().getDetail.exec({
            shopId: shopId,
            typeValue: "PC"
        });
    }), apiResponse = ref14.data;
    var ref15 = (0,dist/* default */.ZP)(apiResponse ? "re-list-".concat(shopId) : null, function() {
        var ref, ref1, ref2;
        var agencyType = (0,lodash.includes)([
            "S01",
            "S02",
            "S03",
            "S04"
        ], apiResponse === null || apiResponse === void 0 ? void 0 : (ref = apiResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.type) === null || ref1 === void 0 ? void 0 : ref1.code) ? "02" : "01";
        return (0,client/* shopDetailGateway */.f)().getAgents.exec({
            agencyCode: (apiResponse === null || apiResponse === void 0 ? void 0 : (ref2 = apiResponse.data) === null || ref2 === void 0 ? void 0 : ref2.shopCode) || "",
            agencyType: agencyType
        });
    }), rdApiResponse = ref15.data;
    var getKey = function() {
        var query = query_string.stringify({
            page: 1,
            size: 30,
            shopId: String(shopId),
            exhibitHall: tabState.code,
            sort: "R",
            typeValue: "P"
        });
        return "shop_detail_".concat(query);
    };
    var ref16 = (0,infinite_dist/* default */.ZP)(getKey, function(query) {
        setIsLoading(_objectSpreadProps(_objectSpread({}, isLoading), {
            constructDataState: false
        }));
        return (0,gateway_client/* constructionCaseGateway */.w)().getList.exec(query_string.parse(query));
    }), constructData = ref16.data;
    var handleLevel = function(num) {
        if (num >= shop/* SOUTH_KOREA_LEVEL_MAX */.b_) {
            setLevel(shop/* SOUTH_KOREA_LEVEL_MAX */.b_);
        } else if (num === 1) {
            setLevel(1);
        } else {
            setLevel(num);
        }
    };
    var handleGetApartRank = (0,react.useCallback)(useShopDetail_asyncToGenerator(runtime_default().mark(function _callee() {
        var res, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,client/* shopDetailGateway */.f)().getApartRanksList.exec({
                        shopId: shopId
                    });
                case 2:
                    res = _ctx.sent;
                    if (res.code === 200) {
                        ;
                        setApartRankList((ref = res.data) === null || ref === void 0 ? void 0 : ref.ranks);
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        shopId
    ]);
    // quickReserveYn 타입 추가 필요
    var shopDetail = (0,react.useMemo)(function() {
        if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            setIsLoading(_objectSpreadProps(_objectSpread({}, isLoading), {
                detailDataState: true
            }));
            var _data = apiResponse.data, id = _data.id, name = _data.name, type = _data.type, telNumber = _data.telNumber, vrView = _data.vrView, address = _data.address, amenities = _data.amenities, mainImages = _data.mainImages, includeItems = _data.includeItems, operateTime = _data.operateTime, floorGuides = _data.floorGuides, exhibitHalls = _data.exhibitHalls, scrapYn = _data.scrapYn, badges = _data.badges, reserveVisitYn = _data.reserveVisitYn, quickReserveYn = _data.quickReserveYn;
            var rdConsultants = [];
            if (rdApiResponse && rdApiResponse.data) {
                var ref7;
                rdConsultants = ((ref7 = rdApiResponse.data) === null || ref7 === void 0 ? void 0 : ref7.map(function(data) {
                    var ref, ref1, ref2;
                    return {
                        id: Number(data.agentDetail.code) || 0,
                        code: data.agentDetail.code || "",
                        name: "".concat(data.agentDetail.name, " RD") || 0,
                        description: data.agentDetail.introduction || "",
                        image: {
                            url: ((ref = data.agentDetail.image) === null || ref === void 0 ? void 0 : ref.url) || ""
                        },
                        shop: {
                            id: data.agency.id,
                            name: data.agency.name,
                            type: {
                                name: ((ref1 = data.agency.type) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                                code: ((ref2 = data.agency.type) === null || ref2 === void 0 ? void 0 : ref2.code) || "",
                                groupCode: ""
                            }
                        },
                        isRD: true
                    };
                })) || [];
            }
            var translateOperateTime = function(operateTime) {
                var splitedOperateTime = operateTime === null || operateTime === void 0 ? void 0 : operateTime.split(": ");
                return {
                    day: splitedOperateTime && splitedOperateTime[0] + ":",
                    time: splitedOperateTime && splitedOperateTime[1]
                };
            };
            var shopDetail = {
                shopId: id,
                sldToCd: apiResponse === null || apiResponse === void 0 ? void 0 : (ref = apiResponse.data) === null || ref === void 0 ? void 0 : ref.shopCode,
                header: {
                    name: name,
                    type: type,
                    telNumber: (telNumber === null || telNumber === void 0 ? void 0 : telNumber.telYn) === "Y" && (telNumber === null || telNumber === void 0 ? void 0 : telNumber.number.length) > 6 && (telNumber === null || telNumber === void 0 ? void 0 : telNumber.number.indexOf("000-0000")) === -1 ? _objectSpread({}, telNumber) : {
                        telYn: "N",
                        number: ""
                    },
                    vrView: vrView,
                    address: address,
                    amenities: amenities ? "편의시설: ".concat(amenities) : "",
                    mainImages: mainImages,
                    includeItem: includeItems === null || includeItems === void 0 ? void 0 : includeItems.reduce(function(prev, curr, index) {
                        var newName = index !== includeItems.length - 1 ? curr.name + ", " : curr.name;
                        return prev + newName;
                    }, ""),
                    operateTime: {
                        weekday: translateOperateTime(operateTime === null || operateTime === void 0 ? void 0 : operateTime.weekday),
                        weekend: translateOperateTime(operateTime === null || operateTime === void 0 ? void 0 : operateTime.weekend),
                        closed: translateOperateTime(operateTime === null || operateTime === void 0 ? void 0 : operateTime.closed)
                    },
                    floorGuides: floorGuides.map(function(floorGuide) {
                        return {
                            floor: floorGuide.floor ? floorGuide.floor + "층" : "",
                            description: floorGuide.description.split(",").map(function(word) {
                                return lodash_default().trim(word);
                            }).join(", ")
                        };
                    }),
                    badges: badges,
                    description: (exhibitHalls === null || exhibitHalls === void 0 ? void 0 : (ref1 = exhibitHalls[0]) === null || ref1 === void 0 ? void 0 : ref1.intro.description) || ""
                },
                bottomBar: {
                    id: id,
                    isScrap: scrapYn === "Y",
                    imageUrl: mainImages === null || mainImages === void 0 ? void 0 : (ref2 = mainImages[0]) === null || ref2 === void 0 ? void 0 : ref2.url,
                    name: name,
                    type: type,
                    reserveVisitYn: reserveVisitYn === "Y",
                    quickReserveYn: quickReserveYn === "Y"
                }
            };
            switch(type.code){
                case "S01":
                case "S02":
                    shopDetail.exhibitHallList = exhibitHalls === null || exhibitHalls === void 0 ? void 0 : exhibitHalls.map(function(exhibitHall) {
                        return _objectSpreadProps(_objectSpread({}, exhibitHall), {
                            consultants: exhibitHall.code === "RM" && rdConsultants ? rdConsultants : exhibitHall.code === "KCBR" ? [] : exhibitHall.consultants,
                            name: "".concat(exhibitHall.name, "관"),
                            id: id
                        });
                    });
                    break;
                case "S03":
                    shopDetail.exhibitHallList = exhibitHalls === null || exhibitHalls === void 0 ? void 0 : exhibitHalls.map(function(exhibitHall) {
                        return _objectSpreadProps(_objectSpread({}, exhibitHall), {
                            consultants: exhibitHall.code === "KCBR" && rdConsultants ? rdConsultants : [],
                            name: "".concat(exhibitHall.name, "관"),
                            id: id
                        });
                    });
                    break;
                case "S04":
                    shopDetail.exhibitHallList = exhibitHalls === null || exhibitHalls === void 0 ? void 0 : exhibitHalls.map(function(exhibitHall) {
                        return _objectSpreadProps(_objectSpread({}, exhibitHall), {
                            name: "".concat(exhibitHall.name, "관"),
                            id: id
                        });
                    });
                    break;
                case "S05":
                case "S06":
                    shopDetail.agentRhkb = {
                        id: id,
                        code: (0,lodash.get)((0,lodash.first)(exhibitHalls), "code", "RM"),
                        images: (0,lodash.get)((0,lodash.first)(exhibitHalls), "images", []),
                        consultants: rdConsultants,
                        badges: (0,lodash.get)((0,lodash.first)(exhibitHalls), "badges", []).map(function(badge) {
                            return _objectSpreadProps(_objectSpread({}, badge), {
                                description: badge.description.split("\\n")
                            });
                        }),
                        apartRanks: (0,lodash.get)((0,lodash.first)(exhibitHalls), "apartRanks", []),
                        consultantShowYn: (0,lodash.get)((0,lodash.first)(exhibitHalls), "consultantShowYn", "N")
                    };
                    break;
                default:
                    shopDetail.agentInterior = {
                        id: id,
                        code: (0,lodash.get)((0,lodash.first)(exhibitHalls), "code", "RM"),
                        images: (0,lodash.get)((0,lodash.first)(exhibitHalls), "images", []),
                        consultants: (0,lodash.get)((0,lodash.first)(exhibitHalls), "consultants", []),
                        consultantShowYn: (0,lodash.get)((0,lodash.first)(exhibitHalls), "consultantShowYn", "N")
                    };
                    break;
            }
            switch(type.code){
                case "S01":
                    shopDetail.header.tooltipTitle = "한샘 ".concat(name, "?");
                    shopDetail.header.tooltipDescription = "홈 리모델링부터 가구, 생활용품까지 집 꾸밈의 모든 것을 한번에 만나볼 수 있는 한샘의 프리미엄 직영매장";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_DESIGNPARK */.Rv;
                    break;
                case "S02":
                    shopDetail.header.tooltipTitle = "한샘리하우스란?";
                    shopDetail.header.tooltipDescription = "자재 선택부터 컨설팅까지 홈 리모델링에 대한 원스톱 서비스를 제공하는 토탈 홈 리모델링 전문 매장";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_SHOWROOM */.rI;
                    break;
                case "S03":
                    shopDetail.header.tooltipTitle = "한샘키친&바스란?";
                    shopDetail.header.tooltipDescription = "매월 1만건 이상의 설계와 시공으로 국내 최고 수준의 전문성을 지닌 부엌 & 욕실 프리미엄 매장";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_SHOWROOM */.rI;
                    break;
                case "S04":
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jj;
                    break;
                case "S05":
                    shopDetail.header.tooltipTitle = "리하우스 대리점이란?";
                    shopDetail.header.tooltipDescription = "홈 리모델링에 대한 원스톱 서비스를 제공하는 한샘 공식 대리점";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_RHKB */.Nz;
                    break;
                case "S06":
                    shopDetail.header.tooltipTitle = "키친&바스 대리점이란?";
                    shopDetail.header.tooltipDescription = "부엌 & 욕실 공사에 대한 원스톱 서비스를 제공하는 한샘 공식 대리점";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_RHKB */.Nz;
                    break;
                case "S07":
                    shopDetail.header.tooltipTitle = "홈퍼니싱 대리점이란?";
                    shopDetail.header.tooltipDescription = "한샘의 침대, 소파, 책상 등 인테리어 가구를 만나볼 수 있는 공식 대리점";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jj;
                    break;
                case "S11":
                    shopDetail.header.tooltipTitle = "보여주는 집이란?";
                    shopDetail.header.tooltipDescription = "한샘으로 시공된 주거 현장에 고객이 직접 방문하여 체험 할 수 있는 고객 체험형 공간";
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jj;
                    break;
                default:
                    shopDetail.viewType = shop/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jj;
                    break;
            }
            setTabState({
                code: (shopDetail === null || shopDetail === void 0 ? void 0 : (ref3 = shopDetail.exhibitHallList) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.code) || "",
                name: (shopDetail === null || shopDetail === void 0 ? void 0 : (ref5 = shopDetail.exhibitHallList) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
                index: 0
            });
            return shopDetail;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        apiResponse,
        apartRankList,
        rdApiResponse
    ]);
    var constructList = (0,react.useMemo)(function() {
        if (constructData === null || constructData === void 0 ? void 0 : constructData[0].data) {
            setIsLoading(_objectSpreadProps(_objectSpread({}, isLoading), {
                constructDataState: true
            }));
            var data = constructData[0].data;
            return data;
        } else {
            return undefined;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        constructData
    ]);
    var handleDeleteScraps = (0,react.useCallback)(useShopDetail_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, code, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return deleteScraps.exec({
                        scrapTypeCode: "SHOP",
                        targetId: shopId
                    });
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    message = ref.message;
                    if (!(code !== 200 && message)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 7:
                    return _ctx.abrupt("return", false);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        deleteScraps,
        shopId
    ]);
    var handleConstructionPopup = function() {
        popupOpen({
            popupProps: {
                buttonType: "noneBtn",
                scrollControl: false,
                title: "".concat(tabState.name, " 시공사례"),
                popupSize: "xxl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ConstructionPopup, {
                    shopId: shopId,
                    tabState: tabState.code
                })
            }
        });
    };
    var handleGoScrap = (0,react.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com", "/mypage/wishList.do"));
    }, [
        router
    ]);
    var handleCreateScraps = (0,react.useCallback)(useShopDetail_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, code, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return createScraps.exec({
                        scrapTypeCode: "SHOP",
                        target: {
                            id: shopId,
                            name: shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.header.name,
                            landingUrl: window.location.href,
                            imageUrl: shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.header.mainImages[0].url
                        }
                    });
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    message = ref.message;
                    if (!(code !== 200 && message)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 7:
                    toast.success("찜 목록에 추가하였습니다.", {
                        placement: "bottom",
                        variant: "button",
                        actionButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, {
                            size: "lg",
                            isUnderline: true,
                            color: "color_chip.white",
                            onClick: handleGoScrap,
                            width: 74,
                            children: "찜 목록가기"
                        }),
                        offset: 87,
                        zIndex: styles/* TOAST_Z_INDEX */.kb
                    });
                    return _ctx.abrupt("return", true);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        createScraps,
        handleGoScrap,
        shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.header.mainImages,
        shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.header.name,
        shopId,
        toast, 
    ]);
    var handleScrap = (0,react.useCallback)(useShopDetail_asyncToGenerator(runtime_default().mark(function _callee() {
        var scrapResult, ref, ref1, ref2, ref3, ref4, scrapResult1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAuthenticated) {
                        _ctx.next = 3;
                        break;
                    }
                    modalOpen({
                        modalProps: {
                            type: "confirm",
                            text: "로그인 후 이용 가능합니다.\n로그인 하시겠습니까?",
                            gtmName: "login_modal",
                            onConfirm: useShopDetail_asyncToGenerator(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return loginGateway.exec();
                                        case 2:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        }
                    });
                    return _ctx.abrupt("return");
                case 3:
                    if (!isScrap) {
                        _ctx.next = 11;
                        break;
                    }
                    setIsScrap(false);
                    _ctx.next = 7;
                    return handleDeleteScraps();
                case 7:
                    scrapResult = _ctx.sent;
                    setIsScrap(scrapResult);
                    _ctx.next = 18;
                    break;
                case 11:
                    ;
                    setIsScrap(true);
                    _ctx.next = 15;
                    return handleCreateScraps();
                case 15:
                    scrapResult1 = _ctx.sent;
                    setIsScrap(scrapResult1);
                    logCustomEvent({
                        eventName: "bz_add_scrap_store",
                        eventProperties: {
                            bz_store_type: shopDetail === null || shopDetail === void 0 ? void 0 : (ref = shopDetail.bottomBar) === null || ref === void 0 ? void 0 : (ref1 = ref.type) === null || ref1 === void 0 ? void 0 : ref1.name,
                            bz_store_area: shopDetail === null || shopDetail === void 0 ? void 0 : (ref2 = shopDetail.header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.basic,
                            bz_store_num: lodash_default().toString(shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.shopId),
                            bz_store_name: shopDetail === null || shopDetail === void 0 ? void 0 : (ref4 = shopDetail.header) === null || ref4 === void 0 ? void 0 : ref4.name
                        }
                    });
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isAuthenticated,
        isScrap,
        modalOpen,
        loginGateway,
        handleDeleteScraps,
        handleCreateScraps,
        logCustomEvent,
        shopDetail === null || shopDetail === void 0 ? void 0 : (ref = shopDetail.bottomBar) === null || ref === void 0 ? void 0 : (ref1 = ref.type) === null || ref1 === void 0 ? void 0 : ref1.name,
        shopDetail === null || shopDetail === void 0 ? void 0 : (ref2 = shopDetail.header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.basic,
        shopDetail === null || shopDetail === void 0 ? void 0 : (ref4 = shopDetail.header) === null || ref4 === void 0 ? void 0 : ref4.name,
        shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.shopId, 
    ]);
    // OP04_01(리하우스대리점) | OP04_02(디자인파크)
    var handleConsult = (0,react.useCallback)(function(consultType) {
        var channelType = consultType === "HF" ? "OP20_01" : "OP04_02";
        if (consultType === "HF") {
            var ref;
            router.push({
                pathname: "/visit-consult/request",
                query: {
                    shopId: shopId,
                    channelType: channelType,
                    channelUrl: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || ""
                }
            });
        } else {
            var ref1;
            router.push({
                pathname: "/seq-consult",
                query: {
                    channelId: shopId,
                    channelType: channelType,
                    channelUrl: (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href) || ""
                }
            });
        }
    }, [
        router,
        shopId
    ]);
    var handleLinkOpen = (0,react.useCallback)(function(link) {
        router.push(link);
    }, [
        router
    ]);
    var handleOpenConsultPopup = (0,react.useCallback)(function() {
        setIsOpenConsultPopup(true);
    }, []);
    var handleCloseConsultPopup = (0,react.useCallback)(function() {
        setIsOpenConsultPopup(false);
    }, []);
    (0,react.useEffect)(function() {
        if (shopDetail) {
            setIsScrap(shopDetail.bottomBar.isScrap);
        }
    }, [
        shopDetail
    ]);
    (0,react.useEffect)(function() {
        handleGetApartRank();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        level: level,
        isScrap: isScrap,
        handleScrap: handleScrap,
        shopDetail: shopDetail,
        isLoading: isLoading,
        constructList: constructList,
        handleConsult: handleConsult,
        handleLinkOpen: handleLinkOpen,
        apartRankList: apartRankList,
        handleConstructionPopup: handleConstructionPopup,
        tabState: tabState,
        setTabState: setTabState,
        handleLevel: handleLevel,
        isOpenConsultPopup: isOpenConsultPopup,
        handleOpenConsultPopup: handleOpenConsultPopup,
        handleCloseConsultPopup: handleCloseConsultPopup
    };
};
/* harmony default export */ var hooks_useShopDetail = (useShopDetail);

// EXTERNAL MODULE: ./src/constants/index.ts + 7 modules
var constants = __webpack_require__(5445);
// EXTERNAL MODULE: ./src/hooks/useDisplayComponent.tsx
var useDisplayComponent = __webpack_require__(2095);
// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(9676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@display-component-pc-virtual-4843018c89/0/cache/@display-component-pc-npm-5.0.5-beta.4-8d5a04944d-e6b425577d.zip/node_modules/@display-component/pc/dist/display-component-pc.js
var display_component_pc = __webpack_require__(823);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.4-c63bd6daca/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(8041);
;// CONCATENATED MODULE: ./src/components/SlideBox/SlideBox.tsx
function SlideBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SlideBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SlideBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var SlideBox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* SlideBox */.hC, SlideBox_objectSpread({}, props));
};
/* harmony default export */ var SlideBox_SlideBox = (SlideBox);

;// CONCATENATED MODULE: ./src/components/SlideBox/index.tsx
/* 작성자 : 양창훈 */ 

// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.4-c63bd6daca/node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(8883);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-8.4.4-c63bd6daca/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(6859);
// EXTERNAL MODULE: ./src/hooks/index.tsx + 5 modules
var hooks = __webpack_require__(3951);
;// CONCATENATED MODULE: ./src/ui/Icons/Close20Icon.tsx
function Close20Icon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Close20Icon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Close20Icon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Close20Icon_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Close20Icon_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Close20Icon_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function Close20Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", Close20Icon_objectSpreadProps(Close20Icon_objectSpread({}, props), {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8272 5.1065C14.5343 4.81361 14.0594 4.81361 13.7665 5.1065L5.28126 13.5918C4.98837 13.8847 4.98837 14.3596 5.28126 14.6524C5.57416 14.9453 6.04903 14.9453 6.34192 14.6524L14.8272 6.16716C15.1201 5.87427 15.1201 5.3994 14.8272 5.1065Z",
                fill: "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.39936 5.2276C5.69225 4.9347 6.16712 4.9347 6.46002 5.2276L14.9453 13.7129C15.2382 14.0058 15.2382 14.4806 14.9453 14.7735C14.6524 15.0664 14.1775 15.0664 13.8846 14.7735L5.39936 6.28826C5.10646 5.99536 5.10646 5.52049 5.39936 5.2276Z",
                fill: "#121212"
            })
        ]
    }));
}
/* harmony default export */ var Icons_Close20Icon = (Close20Icon);

;// CONCATENATED MODULE: ./src/ui/Tooltip/Tooltip.tsx
function Tooltip_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tooltip_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tooltip_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Tooltip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Tooltip_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Tooltip_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Tooltip_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Tooltip_templateObject() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  position: relative;\n\n  width: fit-content;\n  height: fit-content;\n"
    ]);
    Tooltip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tooltip_templateObject1() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n          left: 50%;\n          transform: translateX(-50%);\n        "
    ]);
    Tooltip_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tooltip_templateObject2() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n          left: 0px;\n        "
    ]);
    Tooltip_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Tooltip_templateObject3() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 99;\n  top: calc(100% + 4px);\n  left: 0px;\n  ",
        ";\n\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  width: 232px;\n  padding: 16px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  color: ",
        ";\n"
    ]);
    Tooltip_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Tooltip_templateObject4() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    Tooltip_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  display: block;\n  flex: 1;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = Tooltip_taggedTemplateLiteral([
        "\n  display: block;\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var Tooltip = function(param) {
    var children = param.children, _position = param.position, position = _position === void 0 ? "left" : _position, text = param.text, title = param.title, _gtmName = param.gtmName, gtmName = _gtmName === void 0 ? "" : _gtmName;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useRef)(null);
    (0,hooks/* useOnClickOutside */.t$)(ref1, function() {
        return setIsOpen(false);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContainer, Tooltip_objectSpreadProps(Tooltip_objectSpread({
        ref: ref1
    }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName))), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipIcon, Tooltip_objectSpreadProps(Tooltip_objectSpread({
            onClick: function() {
                return setIsOpen(!isOpen);
            }
        }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_button"))), {
            children: [
                children,
                isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipBox, {
                    position: position,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipTitle, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconWrap, Tooltip_objectSpread({
                                    onClick: function() {
                                        return setIsOpen(false);
                                    }
                                }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_close_button"))))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText, {
                            children: text
                        })
                    ]
                })
            ]
        }))
    }));
};
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);
var TooltipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipContainer",
    componentId: "sc-df20edc4-0"
})(Tooltip_templateObject());
var TooltipBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipBox",
    componentId: "sc-df20edc4-1"
})(Tooltip_templateObject3(), function(param) {
    var position = param.position;
    return position === "center" ? (0,styled_components_browser_esm/* css */.iv)(Tooltip_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(Tooltip_templateObject2());
}, styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white, styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500], styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]);
var TooltipIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipIcon",
    componentId: "sc-df20edc4-2"
})(Tooltip_templateObject4());
var CloseIconWrap = (0,styled_components_browser_esm/* default */.ZP)(Icons_Close20Icon).withConfig({
    displayName: "Tooltip__CloseIconWrap",
    componentId: "sc-df20edc4-3"
})(_templateObject5());
var TooltipHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipHeader",
    componentId: "sc-df20edc4-4"
})(_templateObject6());
var TooltipTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipTitle",
    componentId: "sc-df20edc4-5"
})(_templateObject7(), styles/* theme.typography.headline7 */.rS.typography.headline7);
var TooltipText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Tooltip__TooltipText",
    componentId: "sc-df20edc4-6"
})(_templateObject8(), styles/* theme.typography.body2 */.rS.typography.body2);

;// CONCATENATED MODULE: ./src/ui/Icons/QuestionIcon.tsx


function QuestionIcon(props) {
    var _boxSize, _boxSize1, _fill, _fill1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "16",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.45801 9.40039V9.45898H8.4541V9.40039C8.46875 8.60449 8.69824 8.25293 9.28418 7.89648C9.9043 7.51562 10.2803 6.99316 10.2803 6.20703C10.2803 5.09375 9.43066 4.33203 8.16113 4.33203C6.99902 4.33203 6.06152 5.01074 6.02246 6.25586H7.07715C7.12109 5.5332 7.63379 5.21094 8.16113 5.21094C8.74707 5.21094 9.21582 5.59668 9.21582 6.20703C9.21582 6.71973 8.90332 7.08105 8.49316 7.33008C7.84863 7.73047 7.47266 8.12109 7.45801 9.40039ZM7.30176 10.875C7.29688 11.2559 7.61426 11.5635 7.99512 11.5684C8.37109 11.5635 8.68359 11.2559 8.68848 10.875C8.68359 10.4941 8.37109 10.1816 7.99512 10.1816C7.61426 10.1816 7.29688 10.4941 7.30176 10.875Z",
                fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
                fill: (_fill1 = props.fill) !== null && _fill1 !== void 0 ? _fill1 : "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_QuestionIcon = (QuestionIcon);

;// CONCATENATED MODULE: ./src/ui/GridListBox/GridListBox.tsx
function GridListBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GridListBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GridListBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function GridListBox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function GridListBox_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        GridListBox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function GridListBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function GridListBox_templateObject() {
    var data = GridListBox_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: 80px;\n  :last-child {\n    margin-bottom: 0px;\n  }\n"
    ]);
    GridListBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GridListBox_templateObject1() {
    var data = GridListBox_taggedTemplateLiteral([
        "\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 24px;\n"
    ]);
    GridListBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GridListBox_templateObject2() {
    var data = GridListBox_taggedTemplateLiteral([
        "\n  align-items: center;\n  gap: 4px;\n"
    ]);
    GridListBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GridListBox_templateObject3() {
    var data = GridListBox_taggedTemplateLiteral([
        ""
    ]);
    GridListBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GridListBox_templateObject4() {
    var data = GridListBox_taggedTemplateLiteral([
        ""
    ]);
    GridListBox_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GridListBox_templateObject5() {
    var data = GridListBox_taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: fit-content;\n  cursor: ",
        ";\n"
    ]);
    GridListBox_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var GridListBox = function(param) {
    var title = param.title, imgList = param.imgList, _gridNum = param.gridNum, gridNum = _gridNum === void 0 ? 1 : _gridNum, _colNum = param.colNum, colNum = _colNum === void 0 ? 1 : _colNum, _isAmount = param.isAmount, isAmount = _isAmount === void 0 ? false : _isAmount, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _isArrow = param.isArrow, isArrow = _isArrow === void 0 ? true : _isArrow, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 20 : _spaceBetween, amountNum = param.amountNum, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, tooltip = param.tooltip, _gtmName = param.gtmName, gtmName = _gtmName === void 0 ? "" : _gtmName, gtmValue = param.gtmValue, children = param.children;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridListBox_Container, GridListBox_objectSpreadProps(GridListBox_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName))), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                alignment: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                                variant: "subTitle4",
                                children: title
                            }),
                            isAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderPages, {
                                variant: "subTitle4",
                                children: [
                                    "(",
                                    amountNum || (imgList === null || imgList === void 0 ? void 0 : imgList.length),
                                    ")"
                                ]
                            }),
                            isTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, {
                                title: tooltip === null || tooltip === void 0 ? void 0 : tooltip.title,
                                text: tooltip === null || tooltip === void 0 ? void 0 : tooltip.text,
                                gtmName: gtmName,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_QuestionIcon, {
                                    boxSize: 20
                                })
                            })
                        ]
                    }),
                    isArrow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        space: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, GridListBox_objectSpreadProps(GridListBox_objectSpread({
                                disabled: disabled
                            }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_prev_button"), gtmValue)), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* IconButton */.hU, {
                                    size: "sm",
                                    variant: "ic_arrow_left_bold",
                                    useFillColor: true,
                                    fillColor: disabled ? "color_chip.gray.500" : "color_chip.primary",
                                    onClick: function() {
                                        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
                                    }
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, GridListBox_objectSpreadProps(GridListBox_objectSpread({
                                disabled: disabled
                            }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_next_button"), gtmValue)), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* IconButton */.hU, {
                                    size: "sm",
                                    variant: "ic_arrow_right_bold",
                                    useFillColor: true,
                                    fillColor: disabled ? "color_chip.gray.500" : "color_chip.primary.default",
                                    onClick: function() {
                                        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
                                    }
                                })
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, GridListBox_objectSpreadProps(GridListBox_objectSpread({
                modules: [
                    swiper_esm/* Navigation */.W_
                ],
                onSwiper: setSwiper,
                navigation: true,
                spaceBetween: spaceBetween,
                slidesPerGroup: gridNum,
                slidesPerView: gridNum
            }, tracking/* default.tagGTM */.Z.tagGTM("".concat(gtmName, "_list"), gtmValue)), {
                children: imgList === null || imgList === void 0 ? void 0 : imgList.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        style: {
                            gap: "20px"
                        },
                        children: children({
                            item: item,
                            index: index
                        })
                    }, "slide-box-".concat(index + 1));
                })
            }))
        ]
    }));
};
/* harmony default export */ var GridListBox_GridListBox = (GridListBox);
var GridListBox_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "GridListBox__Container",
    componentId: "sc-4feb8e82-0"
})(GridListBox_templateObject());
var HeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "GridListBox__HeaderContainer",
    componentId: "sc-4feb8e82-1"
})(GridListBox_templateObject1());
var HeaderTitleContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "GridListBox__HeaderTitleContainer",
    componentId: "sc-4feb8e82-2"
})(GridListBox_templateObject2());
var HeaderTitle = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "GridListBox__HeaderTitle",
    componentId: "sc-4feb8e82-3"
})(GridListBox_templateObject3());
var HeaderPages = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "GridListBox__HeaderPages",
    componentId: "sc-4feb8e82-4"
})(GridListBox_templateObject4());
var IconBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "GridListBox__IconBox",
    componentId: "sc-4feb8e82-5"
})(GridListBox_templateObject5(), function(param) {
    var disabled = param.disabled;
    return disabled ? "default" : "pointer";
});

;// CONCATENATED MODULE: ./src/ui/GridListBox/index.ts


;// CONCATENATED MODULE: ./src/ui/Icons/AptRankIcon.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AptRankIcon_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AptRankIcon_templateObject() {
    var data = AptRankIcon_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 36px;\n  height: 44px;\n"
    ]);
    AptRankIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AptRankIcon_templateObject1() {
    var data = AptRankIcon_taggedTemplateLiteral([
        "\n  width: 36px;\n  height: 28px;\n  position: absolute;\n  text-align: center;\n  top: 6px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    AptRankIcon_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function AptRankIcon(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "36",
                height: "44",
                viewBox: "0 0 36 44",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 0H36V44L18 37.1034L0 44V0Z",
                    fill: (ref = props === null || props === void 0 ? void 0 : props.fill) !== null && ref !== void 0 ? ref : "#FFF3B2"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenBox, {
                children: children
            })
        ]
    });
}
/* harmony default export */ var Icons_AptRankIcon = (AptRankIcon);
var BadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AptRankIcon__BadgeContainer",
    componentId: "sc-c8c657a3-0"
})(AptRankIcon_templateObject());
var ChildrenBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AptRankIcon__ChildrenBox",
    componentId: "sc-c8c657a3-1"
})(AptRankIcon_templateObject1(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle4 */.rS.typography.subtitle4);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/AptRank.tsx
function AptRank_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AptRank_templateObject() {
    var data = AptRank_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 39px;\n  align-items: center;\n  padding-left: 42px;\n  padding-right: 42px;\n  width: 100%;\n  height: 180px;\n  border-radius: 2px;\n"
    ]);
    AptRank_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AptRank_templateObject1() {
    var data = AptRank_taggedTemplateLiteral([
        ""
    ]);
    AptRank_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AptRank_templateObject2() {
    var data = AptRank_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  margin-bottom: 4px;\n"
    ]);
    AptRank_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AptRank_templateObject3() {
    var data = AptRank_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 16px;\n  top: 0px;\n"
    ]);
    AptRank_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var AptRank = function(param) {
    var title = param.title, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridListBox_GridListBox, {
        title: title,
        gridNum: 3,
        amountNum: data.length,
        isAmount: true,
        imgList: data,
        disabled: data.length < 4,
        gtmName: "shop_most_construction_apart",
        children: function(param) {
            var item = param.item, index = param.index;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AptRankCard, {
                background: "color_chip.white",
                border: "1px solid",
                borderColor: "color_chip.gray.100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                        variant: "ic_apartment_custom_point_gray",
                        size: 48,
                        resize: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AptRankIcon, {
                            fill: item.rank <= 3 ? "#FFF3B2" : styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100],
                            children: item.rank
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AptRankCardPosition, {
                        variant: "subtitle6",
                        color: "color_chip.primary",
                        children: item.area
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AptRankCardName, {
                        variant: "body2",
                        color: "color_chip.gray.600",
                        children: item.apart
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ui_AptRank = (AptRank);
var AptRankCard = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "AptRank__AptRankCard",
    componentId: "sc-d5ca86dd-0"
})(AptRank_templateObject());
var AptRankCardName = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "AptRank__AptRankCardName",
    componentId: "sc-d5ca86dd-1"
})(AptRank_templateObject1());
var AptRankCardPosition = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "AptRank__AptRankCardPosition",
    componentId: "sc-d5ca86dd-2"
})(AptRank_templateObject2());
var RankIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AptRank__RankIcon",
    componentId: "sc-d5ca86dd-3"
})(AptRank_templateObject3());

;// CONCATENATED MODULE: ./src/ui/Icons/QuoteEndIcon.tsx


function QuoteEndIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M28 3C28 2.44771 27.5523 2 27 2L21.5158 2C20.9635 2 20.5158 2.44772 20.5158 3L20.5158 8.11009C20.5158 8.66238 20.9635 9.11009 21.5158 9.11009L22.9263 9.11009C23.4786 9.11009 23.9393 9.56268 23.8311 10.1043C23.5223 11.6514 22.4729 12.7956 20.846 13.2212C20.3458 13.352 19.9474 13.7719 19.9474 14.289L19.9474 15.9168C19.9474 16.5006 20.4479 16.9652 21.0222 16.8605C25.5098 16.0421 28 12.4739 28 7.91743L28 3ZM18.0526 3C18.0526 2.44771 17.6049 2 17.0526 2L11.5684 2C11.0161 2 10.5684 2.44771 10.5684 3L10.5684 8.11009C10.5684 8.66237 11.0161 9.11009 11.5684 9.11009L12.9789 9.11009C13.5312 9.11009 13.9919 9.56267 13.8838 10.1043C13.5749 11.6514 12.5255 12.7956 10.8986 13.2212C10.3984 13.352 10 13.7719 10 14.289L10 15.9168C10 16.5006 10.5005 16.9652 11.0748 16.8605C15.5625 16.0421 18.0526 12.4739 18.0526 7.91743L18.0526 3Z",
            fill: "#EFEFEF"
        })
    });
}
/* harmony default export */ var Icons_QuoteEndIcon = (QuoteEndIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/QuoteStartIcon.tsx


function QuoteStartIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 14C7 14.5523 7.44772 15 8 15H13.4842C14.0365 15 14.4842 14.5523 14.4842 14V8.88991C14.4842 8.33762 14.0365 7.88991 13.4842 7.88991H12.0737C11.5214 7.88991 11.0607 7.43732 11.1689 6.89573C11.4777 5.34864 12.5271 4.2044 14.154 3.77885C14.6542 3.64801 15.0526 3.22808 15.0526 2.71105V1.08315C15.0526 0.499442 14.5521 0.0348305 13.9778 0.139542C9.49017 0.957861 7 4.52606 7 9.08257V14ZM16.9474 14C16.9474 14.5523 17.3951 15 17.9474 15H23.4316C23.9839 15 24.4316 14.5523 24.4316 14V8.88991C24.4316 8.33762 23.9839 7.88991 23.4316 7.88991H22.0211C21.4688 7.88991 21.0081 7.43732 21.1162 6.89573C21.4251 5.34864 22.4745 4.2044 24.1014 3.77885C24.6016 3.64801 25 3.22808 25 2.71105V1.08315C25 0.499442 24.4995 0.0348305 23.9252 0.139542C19.4375 0.957861 16.9474 4.52606 16.9474 9.08257V14Z",
            fill: "#EFEFEF"
        })
    });
}
/* harmony default export */ var Icons_QuoteStartIcon = (QuoteStartIcon);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/Badges.tsx
function Badges_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Badges_templateObject() {
    var data = Badges_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 217px;\n  display: flex;\n  flex-direction: column;\n  padding-top: 12px;\n  align-items: center;\n"
    ]);
    Badges_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Badges_templateObject1() {
    var data = Badges_taggedTemplateLiteral([
        "\n  margin-top: 20px;\n  margin-bottom: 16px;\n  display: flex;\n"
    ]);
    Badges_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Badges_templateObject2() {
    var data = Badges_taggedTemplateLiteral([
        "\n  padding-left: 26px;\n  padding-right: 30px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Badges_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Badges_templateObject3() {
    var data = Badges_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    Badges_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Badges_templateObject4() {
    var data = Badges_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Badges_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var Badges = function(param) {
    var title = param.title, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridListBox_GridListBox, {
        title: title,
        isTooltip: true,
        isArrow: false,
        spaceBetween: 16,
        tooltip: {
            title: "시공 고객 평가란?",
            text: "해당 대리점에서 리모델링 시공을 받은 고객님들의 평가를 종합한 내용입니다."
        },
        gridNum: 2,
        imgList: data,
        gtmName: "shop_construction_customer_evaluation",
        children: function(param) {
            var item = param.item, index = param.index;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badges_BadgeContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: item.imageUrl,
                        width: "44px",
                        height: "44px",
                        alt: "badgesIcon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeTitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_QuoteStartIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeTitle, {
                                children: item.text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_QuoteEndIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeDescriptionContainer, {
                        children: item.description.map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeDescription, {
                                children: _
                            }, "description_".concat(idx));
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var ui_Badges = (Badges);
var Badges_BadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Badges__BadgeContainer",
    componentId: "sc-14abad79-0"
})(Badges_templateObject());
var BadgeTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Badges__BadgeTitleContainer",
    componentId: "sc-14abad79-1"
})(Badges_templateObject1());
var BadgeTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Badges__BadgeTitle",
    componentId: "sc-14abad79-2"
})(Badges_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle4 */.rS.typography.subtitle4);
var BadgeDescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Badges__BadgeDescriptionContainer",
    componentId: "sc-14abad79-3"
})(Badges_templateObject3());
var BadgeDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Badges__BadgeDescription",
    componentId: "sc-14abad79-4"
})(Badges_templateObject4(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.body1 */.rS.typography.body1);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/Construction.tsx
function Construction_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Construction_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Construction_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Construction_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Construction_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Construction_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Construction_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Construction_templateObject() {
    var data = Construction_taggedTemplateLiteral([
        "\n  margin-bottom: 80px;\n  gap: 24px;\n"
    ]);
    Construction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Construction_templateObject1() {
    var data = Construction_taggedTemplateLiteral([
        "\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    Construction_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Construction_templateObject2() {
    var data = Construction_taggedTemplateLiteral([
        "\n  gap: 4px;\n  align-items: center;\n"
    ]);
    Construction_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Construction_templateObject3() {
    var data = Construction_taggedTemplateLiteral([
        ""
    ]);
    Construction_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Construction_templateObject4() {
    var data = Construction_taggedTemplateLiteral([
        ""
    ]);
    Construction_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Construction_templateObject5() {
    var data = Construction_taggedTemplateLiteral([
        "\n  gap: 2px;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    Construction_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Construction_templateObject6() {
    var data = Construction_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 28px 20px;\n"
    ]);
    Construction_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Construction_templateObject7() {
    var data = Construction_taggedTemplateLiteral([
        "\n  width: ",
        ";\n"
    ]);
    Construction_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var Construction = function(param) {
    var type = param.type, constructData = param.constructData, handleConstructionPopup = param.handleConstructionPopup, gtmValue = param.gtmValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Construction_Container, Construction_objectSpreadProps(Construction_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("constructioncase_list_preview", gtmValue)), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Construction_HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                                variant: "subTitle4",
                                color: "color_chip.primary",
                                children: [
                                    type && "".concat(type, " "),
                                    "시공사례"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataAmount, {
                                variant: "subTitle4",
                                children: [
                                    "(",
                                    constructData === null || constructData === void 0 ? void 0 : constructData.totalElements,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    constructData && (constructData === null || constructData === void 0 ? void 0 : constructData.totalElements) > 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreContainer, Construction_objectSpreadProps(Construction_objectSpread({
                        onClick: handleConstructionPopup
                    }, tracking/* default.tagGTM */.Z.tagGTM("constructioncase_list_preview_more_button", gtmValue)), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "label_lg_r",
                                    color: "color_chip.gray.700",
                                    children: "더보기"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_arrow_right",
                                fillColor: "color_chip.gray.700",
                                useFillColor: true,
                                size: 16,
                                resize: true
                            })
                        ]
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrap, {
                children: constructData === null || constructData === void 0 ? void 0 : constructData.content.map(function(item, index) {
                    return index < 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Construction_CardBox, {
                        width: "375px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstructionCaseCard/* default */.Z, {
                            item: item,
                            imgSize: {
                                width: "375px",
                                height: "211px"
                            }
                        })
                    }, item.id);
                })
            })
        ]
    }));
};
/* harmony default export */ var ui_Construction = (Construction);
var Construction_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "Construction__Container",
    componentId: "sc-9683a717-0"
})(Construction_templateObject());
var Construction_HeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Construction__HeaderContainer",
    componentId: "sc-9683a717-1"
})(Construction_templateObject1());
var TitleContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Construction__TitleContainer",
    componentId: "sc-9683a717-2"
})(Construction_templateObject2());
var Title = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Construction__Title",
    componentId: "sc-9683a717-3"
})(Construction_templateObject3());
var DataAmount = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Construction__DataAmount",
    componentId: "sc-9683a717-4"
})(Construction_templateObject4());
var MoreContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Construction__MoreContainer",
    componentId: "sc-9683a717-5"
})(Construction_templateObject5());
var CardWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Construction__CardWrap",
    componentId: "sc-9683a717-6"
})(Construction_templateObject6());
var Construction_CardBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Construction__CardBox",
    componentId: "sc-9683a717-7"
})(Construction_templateObject7(), function(param) {
    var width = param.width;
    return width;
});

// EXTERNAL MODULE: ./src/components/LoadImage/index.tsx + 1 modules
var LoadImage = __webpack_require__(7119);
;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/Consultant.tsx
function Consultant_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Consultant_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Consultant_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Consultant_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Consultant_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Consultant_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Consultant_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Consultant_templateObject() {
    var data = Consultant_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    Consultant_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Consultant_templateObject1() {
    var data = Consultant_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n  word-break: keep-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    Consultant_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Consultant_templateObject2() {
    var data = Consultant_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n  word-break: keep-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    Consultant_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Consultant_templateObject3() {
    var data = Consultant_taggedTemplateLiteral([
        "\n  width: 52px;\n  height: 52px;\n  min-width: 52px;\n  min-height: 52px;\n  overflow: hidden;\n  border-radius: 50%;\n"
    ]);
    Consultant_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var DummyImg = "/assets/images/favorite-test/img_area_1.png";
var Consultant = function(param) {
    var title = param.title, data = param.data, gtmValue = param.gtmValue;
    var parseArray = function() {
        var returnData = [];
        for(var i = 0; i < Math.ceil(data.length / 6); i++){
            returnData.push(data.slice(i * 6, 6 + i * 6));
        }
        return returnData;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridListBox_GridListBox, {
        title: title,
        isAmount: true,
        amountNum: data.length,
        gridNum: 1,
        colNum: 2,
        imgList: parseArray(),
        disabled: data ? data.length < 7 : false,
        gtmName: "shop_consultant",
        children: function(param) {
            var item = param.item, index = param.index;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                flexWrap: "wrap",
                gap: 16,
                children: item.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RDCard, {
                        item: item,
                        gtmValue: gtmValue,
                        index: index
                    }, "RD-".concat(index));
                })
            });
        }
    });
};
/* harmony default export */ var ui_Consultant = (Consultant);
var RDCard = function(param) {
    var item = param.item, gtmValue = param.gtmValue, index = param.index;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var handleClickMoreButton = (0,react.useCallback)(function() {
        router.push("/expert/".concat(item.code));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RDCardWrapper, Consultant_objectSpreadProps(Consultant_objectSpread({
                width: 243,
                height: 84,
                p: 16,
                gap: 10,
                border: "1px solid",
                borderColor: "color_chip.gray.100",
                onClick: function() {
                    return setIsOpen(true);
                }
            }, tracking/* default.tagGTM */.Z.tagGTM("shop_consultant_item_button", Consultant_objectSpread({
                "shop-consultant-id": item.id
            }, gtmValue))), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RDCardProfile, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                            src: (item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.url) || (0,utils/* getAsset */.Nh)(DummyImg),
                            width: "52px",
                            height: "52px",
                            objectFit: "cover",
                            alt: "consultants".concat(index)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RDCardName, {
                                width: 147,
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RDCardBelong, {
                                width: 147,
                                children: item.shop.name
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* LinePopup */.qg, {
                isOpen: isOpen,
                handleClose: function() {
                    return setIsOpen(false);
                },
                zIndex: display_component_pc/* POPUP_Z_INDEX */.$o,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                    width: 344,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Profile */.NZ, {
                            size: "md",
                            src: item === null || item === void 0 ? void 0 : (ref1 = item.image) === null || ref1 === void 0 ? void 0 : ref1.url,
                            defaultImgType: "default_person",
                            fit: "cover",
                            mb: 28
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle4",
                            color: "color_chip.primary",
                            children: item.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "body2",
                            color: "color_chip.gray.600",
                            mt: "8px",
                            children: item.shop.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "body1",
                            color: "color_chip.primary",
                            mt: 16,
                            children: item.description
                        }),
                        item.isRD && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, {
                            emphasis: "low",
                            size: "lg",
                            width: "100%",
                            icon: {
                                align: "right",
                                variant: "ic_arrow_right"
                            },
                            mt: 40,
                            onClick: function() {
                                return handleClickMoreButton();
                            },
                            children: "더 많은 정보 확인하기"
                        })
                    ]
                })
            })
        ]
    });
};
var RDCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "Consultant__RDCardWrapper",
    componentId: "sc-605300f4-0"
})(Consultant_templateObject());
var RDCardBelong = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Consultant__RDCardBelong",
    componentId: "sc-605300f4-1"
})(Consultant_templateObject1(), styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.typography.body2 */.rS.typography.body2);
var RDCardName = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "Consultant__RDCardName",
    componentId: "sc-605300f4-2"
})(Consultant_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle6 */.rS.typography.subtitle6);
var RDCardProfile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Consultant__RDCardProfile",
    componentId: "sc-605300f4-3"
})(Consultant_templateObject3());

;// CONCATENATED MODULE: ./src/ui/Icons/Close48Icon.tsx


function Close48Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "12.6875",
                y: "14.0996",
                width: "2",
                height: "30",
                rx: "1",
                transform: "rotate(-45 12.6875 14.0996)",
                fill: props.fill || "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "33.8984",
                y: "12.6855",
                width: "2",
                height: "30",
                rx: "1",
                transform: "rotate(45 33.8984 12.6855)",
                fill: props.fill || "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_Close48Icon = (Close48Icon);

;// CONCATENATED MODULE: ./src/components/SlideList/SlideList.tsx
function SlideList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SlideList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SlideList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var SlideList = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* SlideList */.o8, SlideList_objectSpread({}, props));
};
/* harmony default export */ var SlideList_SlideList = (SlideList);

;// CONCATENATED MODULE: ./src/components/SlideList/index.tsx
/* 작성자 : 양창훈 */ 

;// CONCATENATED MODULE: ./src/ui/DetailImg/DetailImg.tsx
function DetailImg_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DetailImg_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DetailImg_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DetailImg_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function DetailImg_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        DetailImg_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function DetailImg_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DetailImg_templateObject() {
    var data = DetailImg_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  width: 100vw;\n  height: 100vh;\n  top: 0px;\n  left: 0px;\n  position: fixed;\n  z-index: 999;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n"
    ]);
    DetailImg_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailImg_templateObject1() {
    var data = DetailImg_taggedTemplateLiteral([
        "\n  width: 870px;\n  height: 700px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"
    ]);
    DetailImg_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailImg_templateObject2() {
    var data = DetailImg_taggedTemplateLiteral([
        "\n  align-self: flex-end;\n  margin-bottom: 20px;\n  cursor: pointer;\n"
    ]);
    DetailImg_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DetailImg_templateObject3() {
    var data = DetailImg_taggedTemplateLiteral([
        "\n  width: 870px;\n  height: 528px;\n  margin-bottom: 32px;\n"
    ]);
    DetailImg_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DetailImg_templateObject4() {
    var data = DetailImg_taggedTemplateLiteral([
        "\n  border-radius: 2px;\n  width: 72px;\n  height: 72px;\n  cursor: pointer;\n  box-sizing: border-box;\n  border: ",
        ";\n  overflow: hidden;\n"
    ]);
    DetailImg_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var DetailImg = function(props) {
    var ref = (0,react.useState)(props.currentData), currentImg = ref[0], setCurrentImg = ref[1];
    (0,react.useEffect)(function() {
        setCurrentImg(props.currentData);
        if (!props.isOpen) return;
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = "auto";
        };
    }, [
        props.isOpen,
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: currentImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(DimmedBox, DetailImg_objectSpreadProps(DetailImg_objectSpread({
            isOpen: props.isOpen
        }, tracking/* default.tagGTM */.Z.tagGTM("gallery")), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailImgContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailImgCloseBtn, DetailImg_objectSpreadProps(DetailImg_objectSpread({
                        onClick: function() {
                            return props.onClose(false);
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("gallery_close_button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close48Icon, {
                            fill: styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailImgMain, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "http:".concat(currentImg.url),
                            // layout={'fixed'}
                            width: "870px",
                            height: "528px",
                            objectFit: "contain",
                            alt: "currentImg",
                            // objectPosition={'center'}
                            style: {
                                borderRadius: "2px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideList_SlideList, {
                        baseWidth: 870,
                        itemWidth: 72,
                        itemHeight: 72,
                        gap: 8,
                        columnCount: 11,
                        data: props.data || [],
                        hasArrow: true,
                        top: 16,
                        children: function(param) {
                            var item = param.item, width = param.width, height = param.height;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(DetailImgListItem, DetailImg_objectSpreadProps(DetailImg_objectSpread({
                                onClick: function() {
                                    return setCurrentImg(item);
                                },
                                state: item.url === (currentImg === null || currentImg === void 0 ? void 0 : currentImg.url)
                            }, tracking/* default.tagGTM */.Z.tagGTM("gallery_images_button")), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "http:".concat(item.url),
                                    width: width,
                                    height: height,
                                    alt: "detail_img",
                                    objectFit: "cover"
                                })
                            }));
                        }
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var DetailImg_DetailImg = (DetailImg);
var DimmedBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailImg__DimmedBox",
    componentId: "sc-ee6a8af9-0"
})(DetailImg_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "flex" : "none";
}, styles/* theme.colors.accent_colors.dimmed.4 */.rS.colors.accent_colors.dimmed[4]);
var DetailImgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailImg__DetailImgContainer",
    componentId: "sc-ee6a8af9-1"
})(DetailImg_templateObject1());
var DetailImgCloseBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailImg__DetailImgCloseBtn",
    componentId: "sc-ee6a8af9-2"
})(DetailImg_templateObject2());
var DetailImgMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailImg__DetailImgMain",
    componentId: "sc-ee6a8af9-3"
})(DetailImg_templateObject3());
var DetailImgListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailImg__DetailImgListItem",
    componentId: "sc-ee6a8af9-4"
})(DetailImg_templateObject4(), function(param) {
    var state = param.state;
    return state ? "2px solid ".concat(styles/* theme.colors.accent_colors.blue.default */.rS.colors.accent_colors.blue["default"]) : "2px solid transparent";
});

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/Preview.tsx
function Preview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Preview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Preview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Preview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Preview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Preview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Preview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Preview_templateObject() {
    var data = Preview_taggedTemplateLiteral([
        "\n  position: 'fixed';\n  width: '100vw';\n  height: '100%';\n  left: '0px';\n  top: '0px';\n  z-index: 99999;\n"
    ]);
    Preview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Preview = function(param) {
    var data = param.data, title = param.title, gtmValue = param.gtmValue;
    var ref = (0,react.useState)(undefined), current = ref[0], setCurrent = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridListBox_GridListBox, {
                title: title,
                gridNum: 2,
                imgList: data,
                isAmount: true,
                disabled: data ? data.length < 3 : false,
                gtmName: "shop_preview_image",
                gtmValue: gtmValue,
                children: function(param) {
                    var item = param.item;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, Preview_objectSpreadProps(Preview_objectSpread({
                        onClick: function() {
                            setCurrent(item);
                        },
                        style: {
                            cursor: "pointer"
                        },
                        width: 375,
                        height: 211
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_preview_image_button", gtmValue)), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                            src: "https:".concat(item === null || item === void 0 ? void 0 : item.url),
                            alt: "eventRollingBanner",
                            objectFit: "cover"
                        })
                    }));
                }
            }),
            !!current && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailImg_DetailImg, {
                    isOpen: !!current,
                    onClose: function() {
                        setCurrent(undefined);
                    },
                    data: data,
                    currentData: current
                })
            })
        ]
    });
};
/* harmony default export */ var ui_Preview = (Preview);
var DetailBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Preview__DetailBox",
    componentId: "sc-6b981699-0"
})(Preview_templateObject());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@display-component-shared-virtual-23aa663b22/0/cache/@display-component-shared-npm-4.0.1-4bea83ddfe-bf59763ff9.zip/node_modules/@display-component/shared/dist/display-component-shared.js
var display_component_shared = __webpack_require__(1382);
;// CONCATENATED MODULE: ./src/components/InformedTemplate/InformedTemplate.tsx
function InformedTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function InformedTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            InformedTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var InformedTemplate = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* InformedTemplate */.xC, InformedTemplate_objectSpread({}, props));
};
/* harmony default export */ var InformedTemplate_InformedTemplate = (InformedTemplate);

;// CONCATENATED MODULE: ./src/components/InformedTemplate/index.tsx
/* 작성자 : 양창훈 */ 

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/AgencyContent.tsx
function AgencyContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AgencyContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AgencyContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AgencyContent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function AgencyContent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        AgencyContent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AgencyContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AgencyContent_templateObject() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    AgencyContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject1() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  margin-bottom: 40px;\n"
    ]);
    AgencyContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject2() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  min-height: 24px;\n"
    ]);
    AgencyContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject3() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n"
    ]);
    AgencyContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject4() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  display: block;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    AgencyContent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject5() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  display: block;\n  color: ",
        ";\n  ",
        ";\n  margin-bottom: 80px;\n"
    ]);
    AgencyContent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject6() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: 80px;\n"
    ]);
    AgencyContent_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject7() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  min-height: 318px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n"
    ]);
    AgencyContent_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AgencyContent_templateObject8() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  width: 72px;\n  height: 72px;\n"
    ]);
    AgencyContent_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = AgencyContent_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


















var AgencyContent = function(param) {
    var data = param.data, constructData = param.constructData, handleConstructionPopup = param.handleConstructionPopup, isLoading = param.isLoading, dispTemplateNo = param.dispTemplateNo;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
    var handleLink = (0,useDisplayComponent/* default */.Z)().handleLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgencyContent_Container, AgencyContent_objectSpreadProps(AgencyContent_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("agent_rh_kb")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                children: (data === null || data === void 0 ? void 0 : data.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideBox_SlideBox, {
                    baseHeight: 260,
                    baseWidth: 770,
                    data: data === null || data === void 0 ? void 0 : data.header.mainImages,
                    hasPagination: true,
                    arrowType: "lg",
                    hasInfinite: true,
                    hasArrow: true,
                    children: function(param) {
                        var width = param.width, height = param.height, item = param.item, index = param.index;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: width,
                            height: height,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                src: "http:".concat(item === null || item === void 0 ? void 0 : item.url),
                                alt: "eventRollingBanner".concat(index),
                                objectFit: "cover"
                            })
                        });
                    }
                })
            }),
            isLoading.constructDataState && isLoading.detailDataState ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                        children: (data === null || data === void 0 ? void 0 : (ref = data.header) === null || ref === void 0 ? void 0 : ref.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyContent_TitleContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyContent_Title, {
                                        children: "매장 소개"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                    children: data === null || data === void 0 ? void 0 : (ref1 = data.header) === null || ref1 === void 0 ? void 0 : ref1.description
                                })
                            ]
                        })
                    }),
                    data.viewType === constants/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jjp && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformedTemplate_InformedTemplate, {
                            handleLink: handleLink,
                            module: display_component_shared/* INFORMED_SHOP_DETAIL_INTERIOR_AGENT */.CO,
                            typeValue: display_component_shared/* TYPE_VALUE_PC */.o_,
                            channelCd: "PC"
                        })
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref2 = data.agentRhkb) === null || ref2 === void 0 ? void 0 : ref2.images) && (data === null || data === void 0 ? void 0 : (ref3 = data.agentRhkb) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.images) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Preview, {
                        data: data === null || data === void 0 ? void 0 : (ref5 = data.agentRhkb) === null || ref5 === void 0 ? void 0 : ref5.images,
                        title: "미리보기"
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref6 = data.agentInterior) === null || ref6 === void 0 ? void 0 : ref6.images) && (data === null || data === void 0 ? void 0 : (ref7 = data.agentInterior) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.images) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Preview, {
                        data: data === null || data === void 0 ? void 0 : (ref9 = data.agentInterior) === null || ref9 === void 0 ? void 0 : ref9.images,
                        title: "미리보기"
                    }),
                    !!constructData && constructData.totalElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Construction, {
                        constructData: constructData,
                        handleConstructionPopup: handleConstructionPopup
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref10 = data.agentInterior) === null || ref10 === void 0 ? void 0 : ref10.consultants) && (data === null || data === void 0 ? void 0 : (ref11 = data.agentInterior) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.consultants) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && (data === null || data === void 0 ? void 0 : (ref13 = data.agentInterior) === null || ref13 === void 0 ? void 0 : ref13.consultantShowYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Consultant, {
                        data: data === null || data === void 0 ? void 0 : (ref14 = data.agentInterior) === null || ref14 === void 0 ? void 0 : ref14.consultants,
                        title: "전문 상담사"
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref15 = data.agentRhkb) === null || ref15 === void 0 ? void 0 : ref15.consultants) && (data === null || data === void 0 ? void 0 : (ref16 = data.agentRhkb) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.consultants) === null || ref17 === void 0 ? void 0 : ref17.length) > 0 && (data === null || data === void 0 ? void 0 : (ref18 = data.agentRhkb) === null || ref18 === void 0 ? void 0 : ref18.consultantShowYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Consultant, {
                        data: data === null || data === void 0 ? void 0 : (ref19 = data.agentRhkb) === null || ref19 === void 0 ? void 0 : ref19.consultants,
                        title: "전문 상담사"
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref20 = data.agentRhkb) === null || ref20 === void 0 ? void 0 : ref20.apartRanks) && (data === null || data === void 0 ? void 0 : (ref21 = data.agentRhkb) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.apartRanks) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AptRank, {
                        title: "최다 시공 아파트",
                        data: data === null || data === void 0 ? void 0 : (ref23 = data.agentRhkb) === null || ref23 === void 0 ? void 0 : ref23.apartRanks
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref24 = data.agentRhkb) === null || ref24 === void 0 ? void 0 : ref24.badges) && (data === null || data === void 0 ? void 0 : (ref25 = data.agentRhkb) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.badges) === null || ref26 === void 0 ? void 0 : ref26.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Badges, {
                        title: "시공 고객의 평가 ",
                        data: data === null || data === void 0 ? void 0 : (ref27 = data.agentRhkb) === null || ref27 === void 0 ? void 0 : ref27.badges.slice(0, 2)
                    }),
                    !(data === null || data === void 0 ? void 0 : (ref28 = data.header) === null || ref28 === void 0 ? void 0 : ref28.description) && (!(data === null || data === void 0 ? void 0 : (ref29 = data.agentRhkb) === null || ref29 === void 0 ? void 0 : ref29.images) || (data === null || data === void 0 ? void 0 : (ref30 = data.agentRhkb) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.images) === null || ref31 === void 0 ? void 0 : ref31.length) === 0) && !(data === null || data === void 0 ? void 0 : (ref32 = data.agentRhkb) === null || ref32 === void 0 ? void 0 : ref32.consultants) && (data === null || data === void 0 ? void 0 : (ref33 = data.agentRhkb) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.consultants) === null || ref34 === void 0 ? void 0 : ref34.length) === 0 && (!(data === null || data === void 0 ? void 0 : (ref35 = data.agentRhkb) === null || ref35 === void 0 ? void 0 : ref35.apartRanks) || (data === null || data === void 0 ? void 0 : (ref36 = data.agentRhkb) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.apartRanks) === null || ref37 === void 0 ? void 0 : ref37.length) === 0) && (!constructData || constructData.totalElements === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BangIconBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                    src: (0,utils/* getAsset */.Nh)("/assets/icons/ic_empty_72.svg"),
                                    alt: "errorBangIcon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                                children: "매장 소개 준비 중입니다"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyContent_LoadingBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    width: "40px",
                    height: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                        src: (0,utils/* getAsset */.Nh)("/assets/icons/loading-obj-new.gif"),
                        alt: "loadingIcon"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ui_AgencyContent = (AgencyContent);
var AgencyContent_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__Container",
    componentId: "sc-47c9135b-0"
})(AgencyContent_templateObject());
var ImageBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__ImageBox",
    componentId: "sc-47c9135b-1"
})(AgencyContent_templateObject1());
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__ContentContainer",
    componentId: "sc-47c9135b-2"
})(AgencyContent_templateObject2());
var AgencyContent_TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__TitleContainer",
    componentId: "sc-47c9135b-3"
})(AgencyContent_templateObject3());
var AgencyContent_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__Title",
    componentId: "sc-47c9135b-4"
})(AgencyContent_templateObject4(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle4 */.rS.typography.subtitle4);
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__Description",
    componentId: "sc-47c9135b-5"
})(AgencyContent_templateObject5(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.body1 */.rS.typography.body1);
var BannerBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__BannerBox",
    componentId: "sc-47c9135b-6"
})(AgencyContent_templateObject6());
var ErrorBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__ErrorBox",
    componentId: "sc-47c9135b-7"
})(AgencyContent_templateObject7());
var BangIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__BangIconBox",
    componentId: "sc-47c9135b-8"
})(AgencyContent_templateObject8());
var ErrorText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__ErrorText",
    componentId: "sc-47c9135b-9"
})(_templateObject9(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body1 */.rS.typography.body1);
var AgencyContent_LoadingBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AgencyContent__LoadingBox",
    componentId: "sc-47c9135b-10"
})(_templateObject10());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/FloatingInfo.tsx
function FloatingInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FloatingInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FloatingInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FloatingInfo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FloatingInfo_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FloatingInfo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function FloatingInfo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FloatingInfo_templateObject() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  min-width: 352px;\n  width: 352px;\n  margin-top: 40px;\n  position: sticky;\n  top: 184px;\n  height: fit-content;\n  bottom: 0px;\n"
    ]);
    FloatingInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject1() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 2px;\n  align-items: center;\n"
    ]);
    FloatingInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject2() {
    var data = FloatingInfo_taggedTemplateLiteral([
        ""
    ]);
    FloatingInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject3() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  position: relative;\n  cursor: pointer;\n"
    ]);
    FloatingInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject4() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: 20px;\n"
    ]);
    FloatingInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject5() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  align-items: center;\n  width: 352px;\n  padding-right: 10px;\n  gap: 8px;\n  margin-bottom: 36px;\n"
    ]);
    FloatingInfo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject6() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  min-width: 48px;\n  min-height: 48px;\n  cursor: pointer;\n"
    ]);
    FloatingInfo_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject7() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 24px 28px 24px 36px;\n  max-height: 537px;\n  overflow: auto;\n  border-radius: 2px;\n  background-color: ",
        ";\n"
    ]);
    FloatingInfo_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject8() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  min-width: 60px;\n"
    ]);
    FloatingInfo_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject9() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  display: flex;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid ",
        ";\n  gap: 10px;\n  :first-child {\n    padding-top: 0px;\n  }\n  :last-child {\n    padding-bottom: 0px;\n    border: none;\n  }\n"
    ]);
    FloatingInfo_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function FloatingInfo_templateObject10() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  gap: 4px;\n"
    ]);
    FloatingInfo_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  gap: 8px;\n  word-break: keep-all;\n  text-overflow: ellipsis;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  width: 232px;\n  height: 72px;\n  padding: 16px 12px 16px 16px;\n  gap: 4px;\n  right: 0px;\n  justify-content: space-between;\n  border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  white-space: pre-wrap;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = FloatingInfo_taggedTemplateLiteral([
        "\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}









var infoList = [
    {
        code: "tell",
        name: "전화번호"
    },
    {
        code: "address",
        name: "매장주소"
    },
    {
        code: "items",
        name: "취급항목"
    },
    {
        code: "operatingTime",
        name: "운영시간"
    },
    {
        code: "floorInfo",
        name: "층별정보"
    }, 
];
var consultFields = [
    {
        consultType: "HF",
        icon: "ic_sofa",
        title: "가구, 패브릭",
        subtitle: "직접 체험하고, 스타일링 제안 받기",
        flags: [
            "가구 체험",
            "홈퍼니싱 전문가",
            "스타일링 제안"
        ],
        flagColor: "color_chip.red.50"
    },
    {
        consultType: "RM",
        icon: "ic_remodeling_start",
        title: "전체, 부분 공사",
        subtitle: "우리 집 도면으로 1:1 상담받기",
        flags: [
            "우리집 맞춤",
            "인테리어 전문가",
            "무료 견적"
        ],
        flagColor: "color_chip.blue.50"
    }, 
];
var FloatingInfo = function(param) {
    var data = param.data, isScrap = param.isScrap, handleScrap = param.handleScrap, handleConsult = param.handleConsult, isOpenConsultPopup = param.isOpenConsultPopup, handleOpenConsultPopup = param.handleOpenConsultPopup, handleCloseConsultPopup = param.handleCloseConsultPopup;
    var handleCopy = (0,hooks/* useClipboard */.VP)().handleCopy;
    var ref = (0,react.useState)(false), copyState = ref[0], setCopyState = ref[1];
    var header = data.header, bottomBar = data.bottomBar, viewType = data.viewType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingContainer, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("shop_info")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreKindContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreKind, {
                        variant: "body2",
                        color: "color_chip.gray.700",
                        children: header === null || header === void 0 ? void 0 : header.type.name
                    }),
                    header.type.code !== "S04" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, {
                        title: header === null || header === void 0 ? void 0 : header.tooltipTitle,
                        text: header === null || header === void 0 ? void 0 : header.tooltipDescription,
                        position: "left",
                        gtmName: "shop_info_type_tooltip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingInfo_IconBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_question",
                                size: 16,
                                resize: true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                variant: "subTitle2",
                color: "color_chip.primary",
                children: header === null || header === void 0 ? void 0 : header.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookmarkIcon, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                        onClick: handleScrap
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_bookmark_button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* BookmarkButton */.eZ, {
                            variant: "whiteBG",
                            size: "lg",
                            isChecked: isScrap
                        })
                    })),
                    viewType === constants/* SHOP_DETAIL_VIEW_TYPE_DESIGNPARK */.RvH && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                        size: "lg",
                        emphasis: "high",
                        width: "100%",
                        disabled: !bottomBar.reserveVisitYn,
                        onClick: handleOpenConsultPopup,
                        style: {
                            cursor: !bottomBar.reserveVisitYn ? "default" : "pointer"
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_consult_select_popup_open_button")), {
                        children: "매장 상담 신청"
                    })),
                    viewType === constants/* SHOP_DETAIL_VIEW_TYPE_SHOWROOM */.rIV && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                        size: "lg",
                        emphasis: "high",
                        width: "100%",
                        disabled: !bottomBar.reserveVisitYn,
                        onClick: function() {
                            handleConsult("RM");
                        },
                        style: {
                            cursor: !bottomBar.reserveVisitYn ? "default" : "pointer"
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_sequential_consult_button")), {
                        children: "매장 상담 신청"
                    })),
                    (viewType === constants/* SHOP_DETAIL_VIEW_TYPE_RHKB */.NzR || viewType === constants/* SHOP_DETAIL_VIEW_TYPE_INTERIOR */.Jjp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                        size: "lg",
                        emphasis: "high",
                        width: "100%",
                        disabled: !bottomBar.reserveVisitYn,
                        onClick: function() {
                            handleConsult("HF");
                        },
                        style: {
                            cursor: !bottomBar.reserveVisitYn ? "default" : "pointer"
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_visit_consult_button")), {
                        children: "매장 상담 신청"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContainer, {
                children: infoList.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            item.code === "tell" && (header === null || header === void 0 ? void 0 : header.telNumber.telYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                className: "InfoList",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                        variant: "body2",
                                        color: "color_chip.gray.600",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContents, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                            children: header === null || header === void 0 ? void 0 : header.telNumber.number
                                        })
                                    })
                                ]
                            }),
                            item.code === "address" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                className: "InfoList",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                        variant: "body2",
                                        color: "color_chip.gray.600",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContents, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                            children: [
                                                header === null || header === void 0 ? void 0 : header.address.basic,
                                                " ",
                                                header === null || header === void 0 ? void 0 : header.address.detail
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingInfo_IconBox, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                                        onClick: function() {
                                            handleCopy("".concat(header === null || header === void 0 ? void 0 : header.address.basic, " ").concat(header === null || header === void 0 ? void 0 : header.address.detail));
                                            setCopyState(true);
                                        }
                                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_address_copy_button")), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                variant: "ic_copy",
                                                size: 20,
                                                resize: true
                                            }),
                                            copyState && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyTooltip, {
                                                backgroundColor: "color_chip.white",
                                                border: "1px solid",
                                                borderColor: "color_chip.gray.500",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyTooltipText, {
                                                        variant: "body2",
                                                        color: "color_chip.primary",
                                                        children: "매장 주소가 클립보드에\n복사되었습니다."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyTooltipIcon, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
                                                        onClick: function(e) {
                                                            e.stopPropagation();
                                                            setCopyState(false);
                                                        }
                                                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_address_copy_tooltip_close_button")), {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                            variant: "ic_close",
                                                            size: 16,
                                                            resize: true
                                                        })
                                                    }))
                                                ]
                                            })
                                        ]
                                    }))
                                ]
                            }),
                            item.code === "items" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                className: "InfoList",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                        variant: "body2",
                                        color: "color_chip.gray.600",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContents, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                            children: header === null || header === void 0 ? void 0 : header.includeItem
                                        })
                                    })
                                ]
                            }),
                            item.code === "operatingTime" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                className: "InfoList",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                        variant: "body2",
                                        color: "color_chip.gray.600",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContents, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                                children: [
                                                    header === null || header === void 0 ? void 0 : header.operateTime.weekday.day,
                                                    " ",
                                                    header === null || header === void 0 ? void 0 : header.operateTime.weekday.time
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                                children: [
                                                    " ",
                                                    header === null || header === void 0 ? void 0 : header.operateTime.weekend.day,
                                                    " ",
                                                    header === null || header === void 0 ? void 0 : header.operateTime.weekend.time
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                                children: [
                                                    " ",
                                                    header === null || header === void 0 ? void 0 : header.operateTime.closed.day,
                                                    " ",
                                                    header === null || header === void 0 ? void 0 : header.operateTime.closed.time
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            item.code === "floorInfo" && (header === null || header === void 0 ? void 0 : header.floorGuides.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoListItem, {
                                className: "InfoList",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                                        variant: "body2",
                                        color: "color_chip.gray.600",
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContents, {
                                        children: [
                                            header === null || header === void 0 ? void 0 : header.floorGuides.map(function(_, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                                    children: [
                                                        _.floor,
                                                        " ",
                                                        _.description
                                                    ]
                                                }, "".concat(idx, "_floorInfo"));
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                                children: header === null || header === void 0 ? void 0 : header.amenities
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "info_list_fragment_".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* BasicPopup */.fz, {
                handleClose: handleCloseConsultPopup,
                size: "md",
                title: "상담 분야",
                isOpen: isOpenConsultPopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                    space: 16,
                    my: 12,
                    children: consultFields.map(function(field) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultFieldCard, {
                            data: field,
                            handleConsult: handleConsult
                        }, "select-consult-field-".concat(field.consultType));
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ui_FloatingInfo = (FloatingInfo);
var ConsultFieldCard = function(param) {
    var data = param.data, handleConsult = param.handleConsult;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, FloatingInfo_objectSpreadProps(FloatingInfo_objectSpread({
        width: "100%",
        onClick: function() {
            return handleConsult(data.consultType);
        }
    }, tracking/* default.tagGTM */.Z.tagGTM(data.consultType === "HF" ? "shop_info_visit_consult_button" : "shop_info_sequential_consult_button")), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
            width: "100%",
            padding: "20px 16px 20px 20px",
            space: "space-between",
            border: "1px solid",
            borderColor: "color_chip.gray.200",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                    height: "100%",
                    width: "100%",
                    space: 16,
                    alignment: "start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        height: "100%",
                        space: 24,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                width: 94,
                                height: 94,
                                backgroundColor: "color_chip.gray.50",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                    variant: data.icon,
                                    width: 48,
                                    height: 48,
                                    resize: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                alignment: "start",
                                space: 16,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                        alignment: "start",
                                        space: 2,
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "headline3",
                                                color: "color_chip.primary",
                                                children: data.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "body1",
                                                color: "color_chip.gray.700",
                                                children: data.subtitle
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                        space: 8,
                                        children: data.flags.map(function(flag, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewFlag */.zI, {
                                                variant: "solid",
                                                size: "sm",
                                                content: flag,
                                                color: data.flagColor,
                                                textColor: "color_chip.primary"
                                            }, "bottom-sheet-".concat(data.consultType, "-flag-").concat(index));
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                    variant: "ic_arrow_right_bold",
                    width: 24,
                    height: 24,
                    resize: true
                })
            ]
        })
    }));
};
var FloatingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__FloatingContainer",
    componentId: "sc-1de4107f-0"
})(FloatingInfo_templateObject());
var StoreKindContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__StoreKindContainer",
    componentId: "sc-1de4107f-1"
})(FloatingInfo_templateObject1());
var StoreKind = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "FloatingInfo__StoreKind",
    componentId: "sc-1de4107f-2"
})(FloatingInfo_templateObject2());
var FloatingInfo_IconBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingInfo__IconBox",
    componentId: "sc-1de4107f-3"
})(FloatingInfo_templateObject3());
var StoreName = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "FloatingInfo__StoreName",
    componentId: "sc-1de4107f-4"
})(FloatingInfo_templateObject4());
var ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "FloatingInfo__ButtonContainer",
    componentId: "sc-1de4107f-5"
})(FloatingInfo_templateObject5());
var BookmarkIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__BookmarkIcon",
    componentId: "sc-1de4107f-6"
})(FloatingInfo_templateObject6());
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__InfoContainer",
    componentId: "sc-1de4107f-7"
})(FloatingInfo_templateObject7(), styles/* theme.colors.accent_colors.primary.light */.rS.colors.accent_colors.primary.light);
var InfoTitle = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "FloatingInfo__InfoTitle",
    componentId: "sc-1de4107f-8"
})(FloatingInfo_templateObject8());
var InfoListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__InfoListItem",
    componentId: "sc-1de4107f-9"
})(FloatingInfo_templateObject9(), styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]);
var InfoContents = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "FloatingInfo__InfoContents",
    componentId: "sc-1de4107f-10"
})(FloatingInfo_templateObject10());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__Content",
    componentId: "sc-1de4107f-11"
})(_templateObject11(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.body2 */.rS.typography.body2);
// const ContentTwo = styled.div``;
var CopyTooltip = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingInfo__CopyTooltip",
    componentId: "sc-1de4107f-12"
})(_templateObject12());
var CopyTooltipText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "FloatingInfo__CopyTooltipText",
    componentId: "sc-1de4107f-13"
})(_templateObject13());
var CopyTooltipIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FloatingInfo__CopyTooltipIcon",
    componentId: "sc-1de4107f-14"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/IntroContent.tsx
function IntroContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function IntroContent_templateObject() {
    var data = IntroContent_taggedTemplateLiteral([
        "\n  gap: 8px;\n  margin-bottom: 80px;\n"
    ]);
    IntroContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var IntroContent = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ((data === null || data === void 0 ? void 0 : data.intro.tel) || (data === null || data === void 0 ? void 0 : data.intro.description)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroContent_Container, {
            alignment: "start",
            children: [
                (data === null || data === void 0 ? void 0 : data.intro.tel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                    variant: "headline6",
                    color: "color_chip.gray.700",
                    children: [
                        "전화번호 ",
                        data === null || data === void 0 ? void 0 : data.intro.tel
                    ]
                }),
                (data === null || data === void 0 ? void 0 : data.intro.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                    variant: "body1",
                    color: "color_chip.gray.700",
                    children: data === null || data === void 0 ? void 0 : data.intro.description
                })
            ]
        })
    });
};
/* harmony default export */ var ui_IntroContent = (IntroContent);
var IntroContent_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "IntroContent__Container",
    componentId: "sc-68e00414-0"
})(IntroContent_templateObject());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/HgTab.tsx
function HgTab_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HgTab_templateObject() {
    var data = HgTab_taggedTemplateLiteral([
        "\n  width: 770px;\n  height: 840px;\n"
    ]);
    HgTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var HgTab = function(param) {
    var data = param.data;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_IntroContent, {
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                src: "http:".concat(data === null || data === void 0 ? void 0 : (ref = data.intro) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.url),
                alt: "hgImg"
            })
        ]
    });
};
/* harmony default export */ var ui_HgTab = (HgTab);
var ContentBox = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "HgTab__ContentBox",
    componentId: "sc-73837bdc-0"
})(HgTab_templateObject());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/EnterShop.tsx
function EnterShop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EnterShop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EnterShop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EnterShop_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function EnterShop_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        EnterShop_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function EnterShop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EnterShop_templateObject() {
    var data = EnterShop_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    EnterShop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EnterShop_templateObject1() {
    var data = EnterShop_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n"
    ]);
    EnterShop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EnterShop_templateObject2() {
    var data = EnterShop_taggedTemplateLiteral([
        "\n  margin-top: 4px;\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    EnterShop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EnterShop_templateObject3() {
    var data = EnterShop_taggedTemplateLiteral([
        ""
    ]);
    EnterShop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EnterShop_templateObject4() {
    var data = EnterShop_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  padding: 4px 8px;\n  border-radius: 2px;\n"
    ]);
    EnterShop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var EnterShop = function(param) {
    var title = param.title, data = param.data, handleLinkOpen = param.handleLinkOpen, gtmValue = param.gtmValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridListBox_GridListBox, {
        title: title,
        gridNum: 4,
        imgList: data,
        isAmount: true,
        disabled: data ? data.length < 5 : false,
        gtmName: "shop_entered_agent",
        gtmValue: gtmValue,
        children: function(param) {
            var item = param.item;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(EnterShop_Container, EnterShop_objectSpreadProps(EnterShop_objectSpread({
                onClick: function() {
                    return handleLinkOpen("/shop/".concat(item.id));
                }
            }, tracking/* default.tagGTM */.Z.tagGTM("shop_entered_agent_list_item_button", EnterShop_objectSpread({
                "shop-id": item.id
            }, gtmValue))), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        width: 177,
                        height: 177,
                        borderRadius: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                            src: "https:".concat(item === null || item === void 0 ? void 0 : item.image.url),
                            alt: "eventRollingBanner",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreType, {
                        variant: "body2",
                        color: "color_chip.gray.700",
                        children: item.type.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterShop_StoreName, {
                        variant: "subTitle6",
                        color: "color_chip.primary",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreBadges, {
                        space: 4,
                        alignment: "start",
                        children: item.badges.map(function(items, idx) {
                            return idx < 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                backgroundColor: "color_chip.blue.50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "caption2",
                                    color: "color_chip.blue.500",
                                    children: items.text
                                })
                            }, "".concat(item.id, "-badge-").concat(idx));
                        })
                    })
                ]
            }));
        }
    });
};
/* harmony default export */ var ui_EnterShop = (EnterShop);
var EnterShop_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "EnterShop__Container",
    componentId: "sc-456b41a0-0"
})(EnterShop_templateObject());
var StoreType = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "EnterShop__StoreType",
    componentId: "sc-456b41a0-1"
})(EnterShop_templateObject1());
var EnterShop_StoreName = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "EnterShop__StoreName",
    componentId: "sc-456b41a0-2"
})(EnterShop_templateObject2());
var StoreBadges = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "EnterShop__StoreBadges",
    componentId: "sc-456b41a0-3"
})(EnterShop_templateObject3());
var Badge = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "EnterShop__Badge",
    componentId: "sc-456b41a0-4"
})(EnterShop_templateObject4());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/StoreTab.tsx







var StoreTab = function(param) {
    var data = param.data, tabName = param.tabName, constructData = param.constructData, handleConstructionPopup = param.handleConstructionPopup, handleLinkOpen = param.handleLinkOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_IntroContent, {
                data: data
            }),
            !!(data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : data.images.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Preview, {
                title: "".concat(tabName, " 미리보기"),
                data: data === null || data === void 0 ? void 0 : data.images,
                gtmValue: {
                    "tab-value": tabName
                }
            }),
            !!(data === null || data === void 0 ? void 0 : data.enterShops) && (data === null || data === void 0 ? void 0 : data.enterShops.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_EnterShop, {
                title: "".concat(tabName, "  입점 대리점"),
                handleLinkOpen: handleLinkOpen,
                data: data === null || data === void 0 ? void 0 : data.enterShops,
                gtmValue: {
                    "tab-value": tabName
                }
            }),
            !!constructData && constructData.totalElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Construction, {
                constructData: constructData,
                type: tabName,
                handleConstructionPopup: handleConstructionPopup,
                gtmValue: {
                    "tab-value": tabName
                }
            }),
            !!(data === null || data === void 0 ? void 0 : data.consultants) && (data === null || data === void 0 ? void 0 : data.consultants.length) > 0 && (data === null || data === void 0 ? void 0 : data.consultantShowYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Consultant, {
                title: "".concat(tabName, "  전문 상담사"),
                data: data === null || data === void 0 ? void 0 : data.consultants,
                gtmValue: {
                    "tab-value": tabName
                }
            })
        ]
    });
};
/* harmony default export */ var ui_StoreTab = (/*#__PURE__*/(0,react.memo)(StoreTab));

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/ParkContent.tsx
function ParkContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParkContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ParkContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ParkContent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ParkContent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ParkContent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ParkContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ParkContent_templateObject() {
    var data = ParkContent_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    ParkContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ParkContent_templateObject1() {
    var data = ParkContent_taggedTemplateLiteral([
        "\n  margin-bottom: 40px;\n"
    ]);
    ParkContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ParkContent_templateObject2() {
    var data = ParkContent_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 28px;\n  margin-bottom: 40px;\n"
    ]);
    ParkContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ParkContent_templateObject3() {
    var data = ParkContent_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n"
    ]);
    ParkContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var ParkContent = function(param) {
    var data = param.data, constructData = param.constructData, setTabState = param.setTabState, tabState = param.tabState, isLoading = param.isLoading, handleConstructionPopup = param.handleConstructionPopup, handleLinkOpen = param.handleLinkOpen;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParkContent_Container, ParkContent_objectSpreadProps(ParkContent_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("design_park_show_room")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParkContent_ImageBox, {
                children: (data === null || data === void 0 ? void 0 : data.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideBox_SlideBox, {
                    baseHeight: 260,
                    baseWidth: 770,
                    data: data === null || data === void 0 ? void 0 : (ref = data.header) === null || ref === void 0 ? void 0 : ref.mainImages,
                    hasPagination: true,
                    arrowType: "lg",
                    hasInfinite: true,
                    hasArrow: true,
                    gtmName: "shop_info_main_images",
                    children: function(param) {
                        var width = param.width, height = param.height, item = param.item, index = param.index;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: width,
                            height: height,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                src: "http:".concat(item === null || item === void 0 ? void 0 : item.url),
                                alt: "eventRollingBanner".concat(index),
                                objectFit: "cover"
                            })
                        });
                    }
                })
            }),
            !!(data === null || data === void 0 ? void 0 : data.exhibitHallList) && (data === null || data === void 0 ? void 0 : (ref1 = data.exhibitHallList) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* LineTab */.$9, {
                    boxType: "basic",
                    widthType: "fixed",
                    size: "lg",
                    selectedValue: tabState.name,
                    tabList: data.exhibitHallList.map(function(item, index) {
                        return {
                            tabName: item.name,
                            value: item.name,
                            handleClickTab: function(e) {
                                setTabState(ParkContent_objectSpreadProps(ParkContent_objectSpread({}, item), {
                                    index: index
                                }));
                            }
                        };
                    })
                })
            }),
            isLoading.constructDataState && isLoading.detailDataState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: tabState.code !== "HG" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_StoreTab, {
                    tabName: tabState.name,
                    handleLinkOpen: handleLinkOpen,
                    constructData: constructData,
                    handleConstructionPopup: handleConstructionPopup,
                    data: data === null || data === void 0 ? void 0 : (ref2 = data.exhibitHallList) === null || ref2 === void 0 ? void 0 : ref2[tabState.index]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_HgTab, {
                    data: data === null || data === void 0 ? void 0 : (ref3 = data.exhibitHallList) === null || ref3 === void 0 ? void 0 : ref3[tabState.index]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ParkContent_LoadingBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    width: "40px",
                    height: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                        src: (0,utils/* getAsset */.Nh)("/assets/icons/loading-obj-new.gif"),
                        alt: "loadingIcon"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ui_ParkContent = (ParkContent);
var ParkContent_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ParkContent__Container",
    componentId: "sc-c488b33d-0"
})(ParkContent_templateObject());
var ParkContent_ImageBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ParkContent__ImageBox",
    componentId: "sc-c488b33d-1"
})(ParkContent_templateObject1());
var TabContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ParkContent__TabContainer",
    componentId: "sc-c488b33d-2"
})(ParkContent_templateObject2());
var ParkContent_LoadingBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ParkContent__LoadingBox",
    componentId: "sc-c488b33d-3"
})(ParkContent_templateObject3());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetailCustomerReview/hooks/useShopDetailCustomerReviewCard.tsx

var useShopDetailCustomerReviewCard = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var handleClickExpanded = (0,react.useCallback)(function() {
        setIsExpanded(function(prev) {
            return !prev;
        });
    }, []);
    return {
        isExpanded: isExpanded,
        handleClickExpanded: handleClickExpanded
    };
};
/* harmony default export */ var hooks_useShopDetailCustomerReviewCard = (useShopDetailCustomerReviewCard);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetailCustomerReview/ShopDetailCustomerReviewCard.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ShopDetailCustomerReviewCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ShopDetailCustomerReviewCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ShopDetailCustomerReviewCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ShopDetailCustomerReviewCard_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ShopDetailCustomerReviewCard_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ShopDetailCustomerReviewCard_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ShopDetailCustomerReviewCard = function(param) {
    var review = param.review, tagName = param.tagName, tagValues = param.tagValues;
    var ref = hooks_useShopDetailCustomerReviewCard(), isExpanded = ref.isExpanded, handleClickExpanded = ref.handleClickExpanded;
    var _agntEvalScore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, ShopDetailCustomerReviewCard_objectSpreadProps(ShopDetailCustomerReviewCard_objectSpread({
        backgroundColor: isExpanded ? "color_chip.gray.50" : "color_chip.white",
        minHeight: "182px",
        height: isExpanded ? "auto" : "182px",
        overflow: "hidden",
        style: {
            cursor: "pointer"
        },
        border: "1px solid",
        borderColor: "color_chip.gray.200",
        borderRadius: "2px",
        p: 32,
        width: "100%",
        onClick: handleClickExpanded
    }, tracking/* default.tagGTM */.Z.tagGTM(tagName, ShopDetailCustomerReviewCard_objectSpread({}, tagValues))), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                children: _toConsumableArray(Array(5)).map(function(_, starIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                        variant: "ic_star_solid",
                                        size: 18,
                                        resize: true,
                                        fillColor: starIdx < ((_agntEvalScore = review.agntEvalScore) !== null && _agntEvalScore !== void 0 ? _agntEvalScore : 0) ? "#121212" : "#e2e2e2"
                                    }, "rating-star-".concat(starIdx));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "headline7",
                                color: "color_chip.primary",
                                children: "".concat(review.agntEvalScore, ".0")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "caption3",
                                color: "color_chip.gray.600",
                                children: review.custId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                width: "1px",
                                height: "11px",
                                backgroundColor: "color_chip.gray.400",
                                mx: "8px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "caption3",
                                color: "color_chip.gray.600",
                                children: review.regYmdt
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                variant: "body1",
                color: "color_chip.primary",
                mt: "8px",
                style: {
                    WebkitLineClamp: isExpanded ? "unset" : 4,
                    WebkitBoxOrient: "vertical",
                    display: "-webkit-box",
                    overflow: "hidden",
                    wordBreak: "break-all",
                    lineHeight: "24px"
                },
                children: review.agntEvalConts
            })
        ]
    }));
};
/* harmony default export */ var ShopDetailCustomerReview_ShopDetailCustomerReviewCard = (ShopDetailCustomerReviewCard);

// EXTERNAL MODULE: ./src/utils/emoji.ts
var emoji = __webpack_require__(2463);
;// CONCATENATED MODULE: ./src/feat-components/ShopDetailCustomerReview/hooks/useShopDetailCustomerReview.tsx
function useShopDetailCustomerReview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useShopDetailCustomerReview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useShopDetailCustomerReview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useShopDetailCustomerReview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useShopDetailCustomerReview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useShopDetailCustomerReview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var PAGE_SIZE = 4;
var useShopDetailCustomerReview = function(param) {
    var sldToCd = param.sldToCd, ssrData = param.ssrData;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,client/* shopDetailGateway */.f)(), getShopStatistics = ref7.getShopStatistics, getShopDetailReview = ref7.getShopDetailReview;
    var ref8 = (0,react.useState)("RECOMMENDED"), sortType = ref8[0], setSortType = ref8[1];
    var ref9 = (0,dist/* default */.ZP)(sldToCd ? "shop-statistic-".concat(sldToCd) : null, function() {
        return getShopStatistics.exec({
            sldToCd: sldToCd
        }).then(function(res) {
            return res !== null && res !== void 0 ? res : null;
        });
    }, {
        revalidateOnFocus: false,
        shouldRetryOnError: false
    }), statisticData = ref9.data;
    var getKey = function(pageIndex, previousPageData) {
        var ref, ref1;
        if (!sldToCd) return null;
        if ((previousPageData === null || previousPageData === void 0 ? void 0 : (ref = previousPageData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) return null;
        var nextPage = pageIndex + 1;
        return {
            sldToCd: sldToCd,
            typeValue: "WEB",
            page: nextPage,
            size: PAGE_SIZE,
            sort: sortType
        };
    };
    var ref10 = (0,infinite_dist/* default */.ZP)(getKey, function(params) {
        return getShopDetailReview.exec(params);
    }, {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        fallbackData: (ssrData === null || ssrData === void 0 ? void 0 : ssrData.reviewData) ? [
            ssrData.reviewData
        ] : undefined,
        revalidateIfStale: false,
        revalidateFirstPage: false,
        persistSize: true
    }), reviewPages = ref10.data, setSize = ref10.setSize;
    var reviews = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = reviewPages === null || reviewPages === void 0 ? void 0 : reviewPages.flatMap(function(page) {
            var ref1;
            return (ref = page === null || page === void 0 ? void 0 : (ref1 = page.data) === null || ref1 === void 0 ? void 0 : ref1.content) !== null && ref !== void 0 ? ref : [];
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        reviewPages
    ]);
    var ref11;
    var totalElements = (ref11 = reviewPages === null || reviewPages === void 0 ? void 0 : (ref = reviewPages[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.totalElements) !== null && ref11 !== void 0 ? ref11 : 0;
    var ref12;
    var isLastPage = (ref12 = reviewPages === null || reviewPages === void 0 ? void 0 : (ref2 = reviewPages[reviewPages.length - 1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.last) !== null && ref12 !== void 0 ? ref12 : true;
    var ref13;
    var gdsMeritTagsWithEmoji = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref13 = statisticData === null || statisticData === void 0 ? void 0 : (ref = statisticData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.meritTagCounts) === null || ref1 === void 0 ? void 0 : ref1.map(function(tag) {
            return useShopDetailCustomerReview_objectSpreadProps(useShopDetailCustomerReview_objectSpread({}, tag), {
                emoji: (0,emoji/* getAgntEmoji */.DO)(tag.name)
            });
        })) !== null && ref13 !== void 0 ? ref13 : [];
    }, [
        statisticData === null || statisticData === void 0 ? void 0 : (ref4 = statisticData.data) === null || ref4 === void 0 ? void 0 : ref4.meritTagCounts
    ]);
    var handleClickMore = (0,react.useCallback)(function() {
        if (!isLastPage) {
            setSize(function(prev) {
                return prev + 1;
            });
        }
    }, [
        isLastPage,
        setSize
    ]);
    var handleChangeSort = (0,react.useCallback)(function(e) {
        var value = e.currentTarget.dataset.value;
        if (value === "RECOMMENDED" || value === "LATEST") {
            setSortType(value);
            setSize(1);
        }
    }, [
        setSize
    ]);
    var ref14;
    var hasRating = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref14 = statisticData === null || statisticData === void 0 ? void 0 : (ref = statisticData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.shopStatistics) === null || ref1 === void 0 ? void 0 : ref1.totAvgScore) !== null && ref14 !== void 0 ? ref14 : 0) > 0;
    }, [
        statisticData === null || statisticData === void 0 ? void 0 : (ref5 = statisticData.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.shopStatistics) === null || ref6 === void 0 ? void 0 : ref6.totAvgScore
    ]);
    var hasMeritTags = (0,react.useMemo)(function() {
        return gdsMeritTagsWithEmoji.length > 0;
    }, [
        gdsMeritTagsWithEmoji
    ]);
    var ref15;
    return {
        statistics: (ref15 = statisticData === null || statisticData === void 0 ? void 0 : statisticData.data) !== null && ref15 !== void 0 ? ref15 : null,
        reviews: reviews,
        isLastPage: isLastPage,
        totalElements: totalElements,
        sortType: sortType,
        handleClickMore: handleClickMore,
        handleChangeSort: handleChangeSort,
        gdsMeritTagsWithEmoji: gdsMeritTagsWithEmoji,
        hasRating: hasRating,
        hasMeritTags: hasMeritTags
    };
};
/* harmony default export */ var hooks_useShopDetailCustomerReview = (useShopDetailCustomerReview);

;// CONCATENATED MODULE: ./src/feat-components/ShopDetailCustomerReview/ShopDetailCustomerReview.tsx
function ShopDetailCustomerReview_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ShopDetailCustomerReview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ShopDetailCustomerReview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ShopDetailCustomerReview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ShopDetailCustomerReview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ShopDetailCustomerReview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ShopDetailCustomerReview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || ShopDetailCustomerReview_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ShopDetailCustomerReview_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ShopDetailCustomerReview_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ShopDetailCustomerReview_arrayLikeToArray(o, minLen);
}






var ShopDetailCustomerReview = function(param) {
    var sldToCd = param.sldToCd, ssrData = param.ssrData;
    var ref, ref1, ref2;
    var ref3 = hooks_useShopDetailCustomerReview({
        sldToCd: sldToCd,
        ssrData: ssrData
    }), statistics = ref3.statistics, reviews = ref3.reviews, isLastPage = ref3.isLastPage, totalElements = ref3.totalElements, sortType = ref3.sortType, handleClickMore = ref3.handleClickMore, handleChangeSort = ref3.handleChangeSort, gdsMeritTagsWithEmoji = ref3.gdsMeritTagsWithEmoji, hasRating = ref3.hasRating, hasMeritTags = ref3.hasMeritTags;
    if (!reviews || reviews.length === 0) return null;
    var renderColumn = function(param) {
        var isRightColumn = param.isRightColumn, columnName = param.columnName;
        var columnReviews = reviews.filter(function(_, i) {
            return i % 2 === (isRightColumn ? 1 : 0);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
            flex: 1,
            gap: 16,
            alignItems: "stretch",
            "data-column": columnName,
            children: columnReviews.map(function(review, idx) {
                var gtmIndex = isRightColumn ? idx * 2 + 2 : idx * 2 + 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopDetailCustomerReview_ShopDetailCustomerReviewCard, {
                    review: review,
                    tagName: "shop_detail_review",
                    tagValues: {
                        index: gtmIndex,
                        review: review.intEvalMstId
                    }
                }, "review-".concat(review.intEvalMstId, "-").concat(columnName, "-").concat(idx));
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
        py: 80,
        borderTop: "1px solid",
        borderTopColor: "color_chip.gray.200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                variant: "headline4",
                color: "color_chip.primary",
                mb: 16,
                children: "매장 고객 후기"
            }),
            (hasRating || hasMeritTags) && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                px: 44,
                py: 28,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                    width: "100%",
                    justifyContent: "center",
                    children: [
                        hasRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: "50%",
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                gap: 52,
                                width: "340px",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                gap: 4,
                                                justifyContent: "center",
                                                mb: "12px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                        variant: "ic_star_solid",
                                                        resize: true,
                                                        size: 24,
                                                        color: "color_chip.primary"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "etc01",
                                                        color: "color_chip.primary",
                                                        children: (statistics === null || statistics === void 0 ? void 0 : (ref = statistics.shopStatistics) === null || ref === void 0 ? void 0 : (ref1 = ref.totAvgScore) === null || ref1 === void 0 ? void 0 : ref1.toFixed(1)) || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "caption1",
                                                color: "color_chip.gray.500",
                                                children: "(최근 6개월 후기 기준 산출)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                        gap: 12,
                                        children: Object.entries((statistics === null || statistics === void 0 ? void 0 : (ref2 = statistics.shopStatistics) === null || ref2 === void 0 ? void 0 : ref2.scoreGroups) || {}).sort(function(a, b) {
                                            return Number(b[0]) - Number(a[0]);
                                        }).map(function(param, index) {
                                            var _param = _slicedToArray(param, 2), key = _param[0], count = _param[1];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                                gap: "12px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                                                        space: "end",
                                                        width: "6px",
                                                        height: "50px",
                                                        backgroundColor: "color_chip.gray.200",
                                                        borderRadius: "1px",
                                                        overflow: "hidden",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                            width: "6px",
                                                            height: "".concat(count, "%"),
                                                            backgroundColor: "color_chip.primary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                        variant: "caption3",
                                                        color: "color_chip.gray.500",
                                                        children: [
                                                            key,
                                                            "점"
                                                        ]
                                                    })
                                                ]
                                            }, "score-bar-".concat(index));
                                        })
                                    })
                                ]
                            })
                        }),
                        hasMeritTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: "50%",
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* VStack */.gC, {
                                gap: "8px",
                                width: "364px",
                                children: gdsMeritTagsWithEmoji.map(function(tag) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                variant: "body2",
                                                color: "color_chip.primary",
                                                pr: 16,
                                                children: [
                                                    tag.emoji,
                                                    " ",
                                                    tag.desc
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                flex: 1,
                                                borderBottom: "1px dashed",
                                                borderColor: "color_chip.gray.400"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                variant: "body2",
                                                color: "color_chip.primary",
                                                pl: 12,
                                                children: [
                                                    tag.count,
                                                    "명"
                                                ]
                                            })
                                        ]
                                    }, "gds-merit-tag-".concat(tag.code, "-").concat(tag.name));
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        justifyContent: "space-between",
                        mb: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        variant: "body1",
                                        color: "color_chip.primary",
                                        children: "전체"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "headline6",
                                                color: "color_chip.primary",
                                                children: totalElements
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "body1",
                                                color: "color_chip.primary",
                                                children: "건"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Dropdown */.Lt, {
                                width: "130px",
                                size: "md",
                                selectValue: sortType,
                                placeholder: "추천순",
                                option: {
                                    data: [
                                        {
                                            value: "RECOMMENDED",
                                            text: "추천순",
                                            isDisabled: false
                                        },
                                        {
                                            value: "LATEST",
                                            text: "최신순",
                                            isDisabled: false
                                        }, 
                                    ]
                                },
                                variant: "list",
                                handleChange: handleChangeSort
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        gap: 12,
                        alignment: "start",
                        children: [
                            renderColumn({
                                isRightColumn: false,
                                columnName: "left"
                            }),
                            renderColumn({
                                isRightColumn: true,
                                columnName: "right"
                            })
                        ]
                    }),
                    !isLastPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        textAlign: "center",
                        mt: 20,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, ShopDetailCustomerReview_objectSpreadProps(ShopDetailCustomerReview_objectSpread({
                            emphasis: "low",
                            icon: {
                                align: "right",
                                variant: "ic_arrow_down"
                            },
                            size: "lg",
                            width: "114px",
                            onClick: handleClickMore
                        }, tracking/* default.tagGTM */.Z.tagGTM("interior_review_shop_detail_more_button")), {
                            children: "더보기"
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ShopDetailCustomerReview_ShopDetailCustomerReview = (ShopDetailCustomerReview);

// EXTERNAL MODULE: ./src/ui/Icons/MarkerIcon.tsx
var MarkerIcon = __webpack_require__(3488);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-kakao-maps-sdk-virtual-57dab0af8b/0/cache/react-kakao-maps-sdk-npm-1.1.5-7d3ebd301d-582e0b66b1.zip/node_modules/react-kakao-maps-sdk/lib/index.modern.js
var index_modern = __webpack_require__(3851);
;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ui/ShopMap.tsx
function ShopMap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ShopMap_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ShopMap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ShopMap_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ShopMap_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ShopMap_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ShopMap_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ShopMap_templateObject() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  position: relative;\n"
    ]);
    ShopMap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopMap_templateObject1() {
    var data = ShopMap_taggedTemplateLiteral([
        ""
    ]);
    ShopMap_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopMap_templateObject2() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n      display: flex;\n      padding: 3px 12px 3px 0px;\n      border-radius: 100px;\n      border: 1px solid ",
        ";\n      height: 46px;\n      z-index: 999;\n      align-items: center;\n      background-color: ",
        ";\n      svg {\n        position: relative;\n        left: -2px;\n      }\n    "
    ]);
    ShopMap_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShopMap_templateObject3() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    ShopMap_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShopMap_templateObject4() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n    height: 18px;\n    width: 12px;\n    position: absolute;\n    bottom: -18px;\n    left: 35px;\n    border-bottom: 0px solid transparent;\n    border-top: 8px solid ",
        ";\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n  "
    ]);
    ShopMap_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ShopMap_templateObject5() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    ShopMap_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ShopMap_templateObject6() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  max-width: 208px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    ShopMap_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ShopMap_templateObject7() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n    position: absolute;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    bottom: 20px;\n    right: 20px;\n    z-index: 9;\n    background-color: red;\n  "
    ]);
    ShopMap_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ShopMap_templateObject8() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    ShopMap_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ShopMap_templateObject9() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n    cursor: pointer;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: ",
        ";\n    z-index: 999;\n  "
    ]);
    ShopMap_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ShopMap_templateObject10() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    ShopMap_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ShopMap_templateObject11() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n    width: 100%;\n    height: 1px;\n    background-color: ",
        ";\n  "
    ]);
    ShopMap_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ShopMap_templateObject12() {
    var data = ShopMap_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    ShopMap_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}








var ShopMap = function(param) {
    var center = param.center, name = param.name, level = param.level, shopType = param.shopType, handleLevel = param.handleLevel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_modern/* Map */.D5, {
            center: {
                lat: center === null || center === void 0 ? void 0 : center.latitude,
                lng: center === null || center === void 0 ? void 0 : center.longitude
            },
            style: {
                width: "100%",
                height: "500px"
            },
            zoomable: false,
            level: level,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayContainer, {
                    style: {
                        marginBottom: "40px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* CustomOverlayMap */.le, {
                        position: {
                            lat: center === null || center === void 0 ? void 0 : center.latitude,
                            lng: center === null || center === void 0 ? void 0 : center.longitude
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarkerContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerIcon/* default */.Z, {
                                    fill: styles/* theme.colors.accent_colors.blue.default */.rS.colors.accent_colors.blue["default"],
                                    groupCode: shopType
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopMap_StoreName, {
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonConatiner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIconBox, ShopMap_objectSpreadProps(ShopMap_objectSpread({
                            onClick: function() {
                                return handleLevel(level - 1);
                            }
                        }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_view_map_zoom_plus_button")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_plus_bold",
                                size: 32
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIconBox, ShopMap_objectSpreadProps(ShopMap_objectSpread({
                            onClick: function() {
                                return handleLevel(level + 1);
                            }
                        }, tracking/* default.tagGTM */.Z.tagGTM("shop_info_view_map_zoom_minus_button")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_minus_bold",
                                size: 32
                            })
                        }))
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_ShopMap = (ShopMap);
var MapContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__MapContainer",
    componentId: "sc-7e2fc5fe-0"
})(ShopMap_templateObject());
var OverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__OverlayContainer",
    componentId: "sc-7e2fc5fe-1"
})(ShopMap_templateObject1());
var MarkerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__MarkerContainer",
    componentId: "sc-7e2fc5fe-2"
})(ShopMap_templateObject3(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ShopMap_templateObject2(), _$theme.colors.accent_color.primary.default, _$theme.colors.natural_color.white);
});
var ArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__ArrowIcon",
    componentId: "sc-7e2fc5fe-3"
})(ShopMap_templateObject5(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ShopMap_templateObject4(), _$theme.colors.accent_color.primary.default);
});
var ShopMap_StoreName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__StoreName",
    componentId: "sc-7e2fc5fe-4"
})(ShopMap_templateObject6(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.button.lg_b */.rS.typography.button.lg_b);
var ButtonConatiner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__ButtonConatiner",
    componentId: "sc-7e2fc5fe-5"
})(ShopMap_templateObject8(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ShopMap_templateObject7(), _$theme.colors.natural_color.gray[200]);
});
var ButtonIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__ButtonIconBox",
    componentId: "sc-7e2fc5fe-6"
})(ShopMap_templateObject10(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ShopMap_templateObject9(), _$theme.colors.natural_color.white);
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopMap__Divider",
    componentId: "sc-7e2fc5fe-7"
})(ShopMap_templateObject12(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ShopMap_templateObject11(), _$theme.colors.natural_color.gray[200]);
});

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/ShopDetail.tsx
function ShopDetail_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ShopDetail_templateObject() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-bottom: 100px;\n"
    ]);
    ShopDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopDetail_templateObject1() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  margin-bottom: 80px;\n  gap: 44px;\n  border-bottom: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    ShopDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopDetail_templateObject2() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  width: 774px;\n"
    ]);
    ShopDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShopDetail_templateObject3() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 500px;\n"
    ]);
    ShopDetail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShopDetail_templateObject4() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  margin-bottom: 80px;\n"
    ]);
    ShopDetail_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ShopDetail_templateObject5() {
    var data = ShopDetail_taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: 24px;\n"
    ]);
    ShopDetail_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var ShopDetail = function(param) {
    var shopId = param.shopId, dispTemplateNo = param.dispTemplateNo;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = hooks_useShopDetail({
        shopId: shopId
    }), shopDetail = ref6.shopDetail, level = ref6.level, handleLevel = ref6.handleLevel, constructList = ref6.constructList, handleScrap = ref6.handleScrap, isLoading = ref6.isLoading, isScrap = ref6.isScrap, tabState = ref6.tabState, setTabState = ref6.setTabState, handleLinkOpen = ref6.handleLinkOpen, handleConsult = ref6.handleConsult, handleConstructionPopup = ref6.handleConstructionPopup, isOpenConsultPopup = ref6.isOpenConsultPopup, handleOpenConsultPopup = ref6.handleOpenConsultPopup, handleCloseConsultPopup = ref6.handleCloseConsultPopup;
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    (0,react.useEffect)(function() {
        if (shopDetail !== undefined) {
            logCustomEvent({
                eventName: "bz_view_store",
                eventProperties: {
                    bz_store_type: lodash_default().get(shopDetail, "bottomBar.type.name", ""),
                    bz_store_area: lodash_default().get(shopDetail, "header.address.basic", ""),
                    bz_store_num: lodash_default().toString(lodash_default().get(shopDetail, "shopId", 0)),
                    bz_store_name: lodash_default().get(shopDetail, "header.name", "")
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shopDetail
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shopDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopDetail_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopDetailContainer, {
                    borderState: (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.viewType) === 1 || (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.viewType) === 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopContentsContainer, {
                            children: (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.viewType) === 1 || (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.viewType) === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ParkContent, {
                                data: shopDetail,
                                isLoading: isLoading,
                                constructData: constructList,
                                tabState: tabState,
                                handleConstructionPopup: handleConstructionPopup,
                                handleLinkOpen: handleLinkOpen,
                                setTabState: setTabState
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AgencyContent, {
                                data: shopDetail,
                                isLoading: isLoading,
                                dispTemplateNo: dispTemplateNo,
                                handleConstructionPopup: handleConstructionPopup,
                                constructData: constructList
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_FloatingInfo, {
                            data: shopDetail,
                            handleScrap: handleScrap,
                            handleConsult: handleConsult,
                            isScrap: isScrap,
                            isOpenConsultPopup: isOpenConsultPopup,
                            handleOpenConsultPopup: handleOpenConsultPopup,
                            handleCloseConsultPopup: handleCloseConsultPopup
                        })
                    ]
                }),
                (shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.sldToCd) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopDetailCustomerReview_ShopDetailCustomerReview, {
                    sldToCd: shopDetail.sldToCd
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopDetail_ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomText, {
                            variant: "subTitle4",
                            color: "color_chip.primary",
                            children: "매장위치"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ShopMap, {
                            level: level,
                            handleLevel: handleLevel,
                            center: (ref = shopDetail === null || shopDetail === void 0 ? void 0 : shopDetail.header.address) === null || ref === void 0 ? void 0 : ref.coordinates,
                            name: shopDetail === null || shopDetail === void 0 ? void 0 : (ref1 = shopDetail.header) === null || ref1 === void 0 ? void 0 : ref1.name,
                            shopType: shopDetail === null || shopDetail === void 0 ? void 0 : (ref2 = shopDetail.header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.type) === null || ref3 === void 0 ? void 0 : ref3.groupCode
                        })
                    ]
                }),
                (shopDetail === null || shopDetail === void 0 ? void 0 : (ref4 = shopDetail.header) === null || ref4 === void 0 ? void 0 : ref4.vrView.yn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopDetail_ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomText, {
                            variant: "subTitle4",
                            color: "color_chip.primary",
                            children: "매장 720VR"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomImg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: shopDetail === null || shopDetail === void 0 ? void 0 : (ref5 = shopDetail.header) === null || ref5 === void 0 ? void 0 : ref5.vrView.url,
                                width: "1170px",
                                height: "500px"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ShopDetail_ShopDetail = (ShopDetail);
var ShopDetail_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopDetail__Container",
    componentId: "sc-6b1d0546-0"
})(ShopDetail_templateObject());
var ShopDetailContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopDetail__ShopDetailContainer",
    componentId: "sc-6b1d0546-1"
})(ShopDetail_templateObject1(), function(param) {
    var borderState = param.borderState;
    return borderState ? "1px solid ".concat(styles/* theme.colors.neutral_colors.gray.200 */.rS.colors.neutral_colors.gray[200]) : "none";
}, function(param) {
    var borderState = param.borderState;
    return borderState ? "80px" : "0px";
});
var ShopContentsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopDetail__ShopContentsContainer",
    componentId: "sc-6b1d0546-2"
})(ShopDetail_templateObject2());
var BottomImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopDetail__BottomImg",
    componentId: "sc-6b1d0546-3"
})(ShopDetail_templateObject3());
var ShopDetail_ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopDetail__ContentContainer",
    componentId: "sc-6b1d0546-4"
})(ShopDetail_templateObject4());
var BottomText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "ShopDetail__BottomText",
    componentId: "sc-6b1d0546-5"
})(ShopDetail_templateObject5());

;// CONCATENATED MODULE: ./src/feat-components/ShopDetail/index.ts


// EXTERNAL MODULE: ./src/components/FloatingGroup/index.tsx + 6 modules
var FloatingGroup = __webpack_require__(2141);
;// CONCATENATED MODULE: ./pages/shop/[id]/index.tsx
function _id_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _id_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _id_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var ShopDetailPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
            floatingArea: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingGroup/* FloatingGroup */.X, _id_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("shop_detail_scroll_top_button"))),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopDetail_ShopDetail, _id_objectSpread({}, props))
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _id_ = (ShopDetailPage);


/***/ }),

/***/ 2307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ constructionCaseGateway; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _remodeling_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(378);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3856);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}



var constructionCaseGateway = function() {
    return {
        getList: new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetConstructionCaseListGateway */ .JA(_axios__WEBPACK_IMPORTED_MODULE_2__/* .axios */ .o),
        // 전문가 컨텐츠 여부
        getCheckCounselor: new ClientGetConstructCaseCheckCounselor(_axios__WEBPACK_IMPORTED_MODULE_2__/* .axios */ .o)
    };
};
var ClientGetConstructCaseCheckCounselor = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetConstructCaseCheckCounselor(httpClient) {
        _classCallCheck(this, ClientGetConstructCaseCheckCounselor);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetConstructCaseCheckCounselor.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return _asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var apiResponse, ref;
            return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new _remodeling_content__WEBPACK_IMPORTED_MODULE_1__/* .GetConstructCaseCheckCounselor */ .PY(_this.httpClient).exec();
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code === 200)) {
                            _ctx.next = 6;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", ((ref = apiResponse.data) === null || ref === void 0 ? void 0 : ref.counselorYn.toLocaleLowerCase()) === "true");
                    case 6:
                        return _ctx.abrupt("return", false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetConstructCaseCheckCounselor;
}();


/***/ }),

/***/ 5627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ shopDetailGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3856);
/* harmony import */ var _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3651);
/* harmony import */ var _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4721);



var shopDetailGateway = function() {
    return {
        getDetail: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopDetailGateway */ .UU(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getConsultantList: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopConsultantGateway */ .N5(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getApartRanksList: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetApartRanksGateway */ .JG(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getAgents: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetAgencyAgentsDetailGateway */ .wk(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getShopStatistics: new _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__/* .GetShopStatisticsGateway */ .kC(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getShopDetailReview: new _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__/* .GetShopDetailReviewGateway */ .ZQ(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 2095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1987);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6757);
/* harmony import */ var _display_component_shared__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1382);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1975);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _useGnb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(914);
/* harmony import */ var _di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2885);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(784);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2655);
/* harmony import */ var _services_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9676);
/* provided dependency */ var process = __webpack_require__(8822);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












var useDisplayComponent = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var handleOldOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", wiseLogParam = arguments.length > 1 ? arguments[1] : void 0;
        var targetUrl = _services_tracking__WEBPACK_IMPORTED_MODULE_10__/* ["default"].combineWiseLogParam */ .Z.combineWiseLogParam(url.startsWith("http") ? url : "".concat("https://remodeling.hanssem.com").concat(url.startsWith("/") ? "" : "/").concat(url), wiseLogParam);
        if (true) {
            window.location.href = targetUrl;
        } else {}
    }, [
        router
    ]);
    var ref = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_REMODELING */ ._M,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), remodelingGnbMenuList = ref.gnbList;
    var handleAppLinkGnbRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(remodelingGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_SECTION */ .UY:
                    handleOldOpenUrl("/main", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_GOODS */ .gi:
                    handleOldOpenUrl("/goods", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_SHOP */ .P1:
                    handleOldOpenUrl("/shop/search", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_START */ .Sh:
                    handleOldOpenUrl("/remodeling-start", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_EVENT */ ._L:
                    handleOldOpenUrl("/event", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                case _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .GNB_REMODELING_REHOUSE */ .TH:
                    handleOldOpenUrl("/rehouse", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
                default:
                    handleOldOpenUrl("/main?module=".concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("/", appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        remodelingGnbMenuList
    ]);
    var handleAppLinkCateRemodeling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var query = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
            ctgNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        handleOldOpenUrl("/goods?".concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
    }, [
        handleOldOpenUrl
    ]);
    var ref1 = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_MALL */ .GG,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), mallGnbMenuList = ref1.gnbList;
    var handleAppLinkGnbMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(mallGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/mall.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        mallGnbMenuList
    ]);
    var handleAppLinkCateMall = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if (appLink && appLink.appLinkOption) {
            var categoryClass = appLink.appLinkOption.ctgDepth === "2" ? "L" : appLink.appLinkOption.ctgDepth === "3" ? "M" : "S";
            var query = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
                ctgrNo: appLink.appLinkOption.ctgNo,
                categoryall: "".concat(categoryClass).concat(appLink.appLinkOption.ctgNo)
            });
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/category/goHsm").concat(categoryClass, "ctgy.do?").concat(query), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl
    ]);
    var ref2 = (0,_useGnb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        viewType: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .VIEW_TYPE_HOMEIDEA */ .o2,
        typeValue: _display_component_shared__WEBPACK_IMPORTED_MODULE_11__/* .TYPE_VALUE_MOBILE */ .is
    }), homeIdeaGnbMenuList = ref2.gnbList;
    var handleAppLinkGnbHomeIdea = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var found = lodash__WEBPACK_IMPORTED_MODULE_3___default().find(homeIdeaGnbMenuList, {
            dispTemplateNo: appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal
        });
        if (found) {
            var gnbModule = found.module;
            switch(gnbModule){
                default:
                    handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html?module=").concat(gnbModule), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
                    break;
            }
        } else {
            handleOldOpenUrl("".concat(process.env.NEXT_PUBLIC_HANSSEMMALL_WEB_HOST, "/interior.html"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
        }
    }, [
        handleOldOpenUrl,
        homeIdeaGnbMenuList
    ]);
    var handleLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "LINK") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl(appLink.appLinkVal, appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "GNB") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkGnbMall(appLink);
                    break;
                case "HOMEIDEA":
                    handleAppLinkGnbHomeIdea(appLink);
                    break;
                default:
                    handleAppLinkGnbRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "CATE") {
            switch(appLink === null || appLink === void 0 ? void 0 : appLink.appLinkChannel){
                case "MALL":
                    handleAppLinkCateMall(appLink);
                    break;
                default:
                    handleAppLinkCateRemodeling(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.appLinkTarget) === "PLAN") {
            if (appLink === null || appLink === void 0 ? void 0 : appLink.appLinkVal) {
                handleOldOpenUrl("/event/".concat(appLink.appLinkVal, "?eventStatusType=ING"), appLink === null || appLink === void 0 ? void 0 : appLink.wiseLogParam);
            }
        }
    }, [
        handleAppLinkCateMall,
        handleAppLinkCateRemodeling,
        handleAppLinkGnbHomeIdea,
        handleAppLinkGnbMall,
        handleAppLinkGnbRemodeling,
        handleOldOpenUrl, 
    ]);
    /**
   * appLink와 defaultUrl을 받아 타겟 url로 랜딩하는 함수
   * @param {NewDisplayHandleLinkArgs} appLink 전시 데이터를 담고 있습니다.
   * @param {string} defaultUrl defaultUrl 을 입력하면 linkUrl 이 비어있을때 지정된 defaultUrl 로 이동합니다. linkUrl 과 defaultUrl 둘다 없다면 '/' 로 이동합니다.
   * @returns void
   */ var handleOpenUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink, defaultUrl) {
        var ref;
        if (false) {}
        var ref1;
        var url = (ref1 = (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.linkUrl) !== null && ref1 !== void 0 ? ref1 : defaultUrl || "/";
        if (appLink.isNewWindow) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    }, []);
    var handleNewLink = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(appLink) {
        var ref, ref1, ref2, ref3, ref4;
        ;
        if ((appLink === null || appLink === void 0 ? void 0 : appLink.applink) && !appLink.applink.appLinkTarget || (appLink === null || appLink === void 0 ? void 0 : (ref = appLink.applink) === null || ref === void 0 ? void 0 : ref.appLinkTarget) === "URL") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref1 = appLink.applink) === null || ref1 === void 0 ? void 0 : ref1.appLinkTarget) === "GNB") {
            var ref5;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref5 = appLink.applink) === null || ref5 === void 0 ? void 0 : ref5.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "MALL":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/furnishing"));
                    break;
                case "HOMEIDEA":
                case "REMODELING":
                    handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/interior"));
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref2 = appLink.applink) === null || ref2 === void 0 ? void 0 : ref2.appLinkTarget) === "CATEGORY") {
            handleOpenUrl(appLink);
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref3 = appLink.applink) === null || ref3 === void 0 ? void 0 : ref3.appLinkTarget) === "BNB") {
            var ref6;
            switch(appLink === null || appLink === void 0 ? void 0 : (ref6 = appLink.applink) === null || ref6 === void 0 ? void 0 : ref6.appLinkChannel){
                case "MAIN":
                    handleOpenUrl(appLink);
                    break;
                case "FURNISHING":
                    handleOpenUrl(appLink, "/furnishing");
                    break;
                case "INTERIOR":
                    handleOpenUrl(appLink, "/interior");
                    break;
                case "SHOPSEARCH":
                    handleOpenUrl(appLink, "/shop/search");
                    break;
                case "MY":
                    handleOpenUrl(appLink, "/my");
                    break;
                default:
                    handleOpenUrl(appLink);
                    break;
            }
        }
        if ((appLink === null || appLink === void 0 ? void 0 : (ref4 = appLink.applink) === null || ref4 === void 0 ? void 0 : ref4.appLinkTarget) === "PLAN") {
            var ref7;
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "\n          ").concat(appLink === null || appLink === void 0 ? void 0 : (ref7 = appLink.applink) === null || ref7 === void 0 ? void 0 : ref7.linkUrl).concat(appLink.applink.appLinkAddQuery ? "&" + appLink.applink.appLinkAddQuery : ""));
        }
        if (appLink === null || appLink === void 0 ? void 0 : appLink.goodsInfo) {
            handleOpenUrl(appLink, "".concat("https://store.hanssem.com", "/goods/").concat(appLink.goodsInfo.gdsNo));
        }
    }, [
        handleOpenUrl
    ]);
    var handleLogin = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_di_container_auth_gateway_client__WEBPACK_IMPORTED_MODULE_7__/* .authGateway */ .h)().loginGateway.exec();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var toast = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .pm)().toast;
    var ref3 = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useAlert */ .VY)(), handleAlertOpen = ref3.handleOpen;
    var ref4 = (0,_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .useConfirm */ .N4)(), handleConfirmOpen = ref4.handleOpen, closeConfirm = ref4.handleClose;
    var handleGoScrap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com", "/mypage/wishList.do"));
    }, [
        router
    ]);
    var handleAction = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var message = param.message, action = param.action, type = param.type;
        ;
        if (action === "scrap") {
            toast.success("찜 목록에 추가하였습니다.", {
                placement: "bottom",
                variant: "button",
                actionButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_8__/* .NewTextButton */ .rT, {
                    size: "lg",
                    isUnderline: true,
                    color: "color_chip.white",
                    onClick: handleGoScrap,
                    width: 74,
                    children: "찜 목록가기"
                }),
                offset: 87,
                zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .TOAST_Z_INDEX */ .kb
            });
        } else {
            switch(type){
                case "toast":
                    toast.success(message, {
                        alignment: "center",
                        placement: "bottom",
                        variant: "basic",
                        offset: 87,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .TOAST_Z_INDEX */ .kb
                    });
                    break;
                case "alert":
                    handleAlertOpen({
                        content: message,
                        zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .ALERT_Z_INDEX */ .iO
                    });
                    break;
                case "confirm":
                    if (action === "login") {
                        ;
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            isShowCloseButton: true,
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .CONFIRM_Z_INDEX */ .CJ,
                            handleConfirm: function() {
                                handleLogin();
                            },
                            handleCloseButton: function() {
                                closeConfirm();
                            }
                        });
                    } else {
                        handleConfirmOpen({
                            cancelText: "취소",
                            confirmText: "로그인",
                            content: message,
                            width: "370px",
                            zIndex: _styles__WEBPACK_IMPORTED_MODULE_9__/* .CONFIRM_Z_INDEX */ .CJ
                        });
                    }
                    break;
                default:
                    break;
            }
        }
    }, [
        closeConfirm,
        handleAlertOpen,
        handleConfirmOpen,
        handleGoScrap,
        handleLogin,
        toast, 
    ]);
    return {
        handleLink: handleLink,
        handleNewLink: handleNewLink,
        handleAction: handleAction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDisplayComponent);


/***/ }),

/***/ 7209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ConstructionCaseCard_ConstructionCaseCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(1987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(278);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(2655);
;// CONCATENATED MODULE: ./src/ui/FlagVr/FlagVr.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 70px;\n  height: 28px;\n  border: 0.5px solid\n    ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 66px;\n  height: 24px;\n  background-color: ",
        ";\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var FlagVr = function(param) {
    var _value = param.value, value = _value === void 0 ? 720 : _value, _variant = param.variant, variant = _variant === void 0 ? "imgBG" : _variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagVrWrapper, {
        variant: variant,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlagWrap, {
            variant: variant,
            children: [
                value,
                " VR"
            ]
        })
    });
};
/* harmony default export */ var FlagVr_FlagVr = (FlagVr);
var CommonColor = {
    gray: "rgba(0, 0, 0, 0.16)",
    black: styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"],
    white: styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white
};
var CommonCSS = (0,styled_components_browser_esm/* css */.iv)(_templateObject());
var FlagVrWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FlagVr__FlagVrWrapper",
    componentId: "sc-45a13d2-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variant === "imgBG" ? CommonColor.white : CommonColor.black;
}, CommonCSS);
var FlagWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FlagVr__FlagWrap",
    componentId: "sc-45a13d2-1"
})(_templateObject2(), styles/* theme.typography.button.sm_b */.rS.typography.button.sm_b, function(param) {
    var variant = param.variant;
    return variant === "imgBG" ? CommonColor.gray : CommonColor.white;
}, function(param) {
    var variant = param.variant;
    return variant === "imgBG" ? CommonColor.white : CommonColor.black;
}, CommonCSS);

;// CONCATENATED MODULE: ./src/ui/FlagVr/index.ts


// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(9676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-5c4b6f9b0e/0/cache/@design-system-pc-npm-4.9.1-beta.4-8219a2df4e-f8611c630d.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(784);
// EXTERNAL MODULE: ./src/components/LoadImage/index.tsx + 1 modules
var LoadImage = __webpack_require__(7119);
;// CONCATENATED MODULE: ./src/ui/ConstructionCaseCard/ConstructionCaseCard.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ConstructionCaseCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ConstructionCaseCard_templateObject() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  align-items: start;\n  max-width: 376px;\n  height: auto;\n  cursor: pointer;\n"
    ]);
    ConstructionCaseCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConstructionCaseCard_templateObject1() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  position: relative;\n  border-radius: 2px;\n  height: ",
        ";\n"
    ]);
    ConstructionCaseCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConstructionCaseCard_templateObject2() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 9;\n  bottom: 12px;\n  left: 12px;\n"
    ]);
    ConstructionCaseCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  display: inline-block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  display: inline-block;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  gap: 4px;\n  padding-top: 12px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = ConstructionCaseCard_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}







var ConstructionCaseCard = function(param) {
    var item = param.item, imgSize = param.imgSize;
    var ref;
    var id = item.id, apartment = item.apartment, detailUrl = item.detailUrl, title = item.title, shop = item.shop, imageUrl = item.imageUrl, vrUrl = item.vrUrl;
    var onClickCard = (0,react.useCallback)(function() {
        window.open(detailUrl);
    }, [
        detailUrl
    ]);
    var onClickVr = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        window.open(vrUrl);
    }, [
        vrUrl
    ]);
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, _objectSpreadProps(_objectSpread({
        onClick: onClickCard
    }, tracking/* default.tagGTM */.Z.tagGTM("constructioncase_item_button", {
        "content-id": id
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrap, {
                height: (imgSize === null || imgSize === void 0 ? void 0 : imgSize.height) || "250px",
                children: [
                    vrUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstructionCaseCard_FlagWrap, _objectSpreadProps(_objectSpread({
                        onClick: onClickVr
                    }, tracking/* default.tagGTM */.Z.tagGTM("constructioncase_vr_item_button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagVr_FlagVr, {
                            variant: "imgBG"
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        width: (imgSize === null || imgSize === void 0 ? void 0 : imgSize.width) || "100%",
                        height: (imgSize === null || imgSize === void 0 ? void 0 : imgSize.height) || "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                            src: imageUrl,
                            alt: imageUrl,
                            objectFit: "cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagText, {
                                variant: "body2",
                                color: "color_chip.gray.600",
                                children: apartment === null || apartment === void 0 ? void 0 : (ref = apartment.name) === null || ref === void 0 ? void 0 : ref.substring(0, 6)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagText, {
                                variant: "body2",
                                color: "color_chip.gray.600",
                                children: [
                                    apartment === null || apartment === void 0 ? void 0 : apartment.area,
                                    "㎡"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagText, {
                                variant: "body2",
                                color: "color_chip.gray.600",
                                children: apartment === null || apartment === void 0 ? void 0 : apartment.sidoGungu
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        variant: "body1",
                        color: "color_chip.primary",
                        children: "".concat(title.substring(0, 50))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopInfoWrap, {
                        space: 4,
                        alignment: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Profile */.NZ, {
                                size: "xxxs",
                                src: shop.image,
                                fit: "cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagText, {
                                variant: "body2",
                                color: "color_chip.gray.600",
                                children: shop === null || shop === void 0 ? void 0 : shop.name
                            })
                        ]
                    })
                ]
            })
        ]
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ConstructionCaseCard_ConstructionCaseCard = (ConstructionCaseCard);
var Divider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
        width: "1px",
        height: "10px",
        margin: "0 8px",
        backgroundColor: "color_chip.gray.200",
        display: "inline-block"
    });
};
var CardWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* VStack */.gC).withConfig({
    displayName: "ConstructionCaseCard__CardWrapper",
    componentId: "sc-3a5547b8-0"
})(ConstructionCaseCard_templateObject());
var ImageWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ConstructionCaseCard__ImageWrap",
    componentId: "sc-3a5547b8-1"
})(ConstructionCaseCard_templateObject1(), function(param) {
    var height = param.height;
    return height;
});
var ConstructionCaseCard_FlagWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ConstructionCaseCard__FlagWrap",
    componentId: "sc-3a5547b8-2"
})(ConstructionCaseCard_templateObject2());
var TagWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ConstructionCaseCard__TagWrap",
    componentId: "sc-3a5547b8-3"
})(_templateObject3());
var TitleText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "ConstructionCaseCard__TitleText",
    componentId: "sc-3a5547b8-4"
})(_templateObject4());
var TagText = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Text */.xv).withConfig({
    displayName: "ConstructionCaseCard__TagText",
    componentId: "sc-3a5547b8-5"
})(_templateObject5());
var ShopInfoWrap = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "ConstructionCaseCard__ShopInfoWrap",
    componentId: "sc-3a5547b8-6"
})(_templateObject6());
var TextArea = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ConstructionCaseCard__TextArea",
    componentId: "sc-3a5547b8-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/ui/ConstructionCaseCard/index.ts



/***/ }),

/***/ 3488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1987);


function MarkerIcon(props) {
    if (props.groupCode === "OH") {
        if (props.isHover) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "49",
                height: "49",
                viewBox: "0 0 49 49",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: "24.4492",
                        cy: "24.6845",
                        r: "19",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.4492 22.4237C12.4492 21.9943 12.6681 21.5887 13.0429 21.3233L24.2509 14.4413C24.5329 14.2416 24.9301 14.2416 25.2122 14.4413L35.856 21.3233C36.2309 21.5887 36.4497 21.9943 36.4497 22.4237L36.4497 33.6776C36.4497 34.4508 35.7535 35.0776 34.8947 35.0776H14.0043C13.1454 35.0776 12.4492 34.4508 12.4492 33.6776L12.4492 22.4237Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.0706 27.6543C20.0706 28.2135 19.9606 28.6939 19.7408 29.0953C19.5209 29.4968 19.221 29.8015 18.841 30.0094C18.4611 30.2173 18.0345 30.3213 17.5613 30.3213C17.0834 30.3213 16.6544 30.2173 16.2744 30.0094C15.8945 29.7991 15.5946 29.4932 15.3747 29.0918C15.1549 28.6903 15.0449 28.2111 15.0449 27.6543C15.0449 27.0951 15.1549 26.6148 15.3747 26.2133C15.5946 25.8118 15.8945 25.5071 16.2744 25.2992C16.6544 25.0913 17.0834 24.9874 17.5613 24.9874C18.0345 24.9874 18.4611 25.0913 18.841 25.2992C19.221 25.5071 19.5209 25.8118 19.7408 26.2133C19.9606 26.6148 20.0706 27.0951 20.0706 27.6543ZM16.4501 27.6543C16.4501 28.1299 16.5457 28.4943 16.7369 28.7476C16.928 29.001 17.2029 29.1288 17.5613 29.1312C17.9174 29.1288 18.191 29.001 18.3822 28.7476C18.5734 28.4943 18.6678 28.1299 18.6654 27.6543C18.6678 27.1764 18.5734 26.8107 18.3822 26.5574C18.191 26.3041 17.9174 26.1775 17.5613 26.1775C17.2029 26.1775 16.928 26.3041 16.7369 26.5574C16.5457 26.8107 16.4501 27.1764 16.4501 27.6543Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.5905 25.0591H22.7986C23.181 25.0591 23.5167 25.1355 23.8059 25.2885C24.0974 25.439 24.3221 25.6517 24.4798 25.9265C24.6399 26.2014 24.72 26.5192 24.72 26.88C24.72 27.2457 24.6387 27.5659 24.4762 27.8407C24.3137 28.1132 24.0843 28.3223 23.788 28.468C23.4916 28.6138 23.1475 28.6867 22.7556 28.6867H21.9526V30.2496H20.5905V25.0591ZM22.4832 27.6257C22.7389 27.6233 22.9384 27.5563 23.0818 27.4249C23.2252 27.2911 23.2957 27.1095 23.2933 26.88C23.2957 26.653 23.2252 26.475 23.0818 26.3459C22.9384 26.2169 22.7389 26.1512 22.4832 26.1488H21.9526V27.6257H22.4832Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M25.1108 25.0591H28.8173V26.1631H26.473V27.1023H28.6238V28.2064H26.473V29.1455H28.8102V30.2496H25.1108V25.0591Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M33.8539 30.2496H32.714L30.7854 27.4464H30.7496V30.2496H29.3874V25.0591H30.5489L32.4487 27.8479H32.4917V25.0591H33.8539V30.2496Z",
                        fill: "#0064FF"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "49",
            height: "49",
            viewBox: "0 0 49 49",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "24.2949",
                    cy: "24.6845",
                    r: "21.25",
                    fill: "white",
                    stroke: "#484848",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.89453 21.9715C9.89453 21.4563 10.1571 20.9695 10.607 20.651L24.0565 12.3926C24.395 12.153 24.8716 12.153 25.2101 12.3926L37.9827 20.651C38.4325 20.9695 38.6951 21.4563 38.6951 21.9715L38.6951 35.4762C38.6951 36.4041 37.8597 37.1562 36.8291 37.1562H11.7606C10.73 37.1562 9.89455 36.4041 9.89455 35.4762L9.89453 21.9715Z",
                    fill: "#484848"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.0405 28.2483C19.0405 28.9193 18.9086 29.4957 18.6448 29.9775C18.381 30.4593 18.0211 30.8249 17.5651 31.0744C17.1091 31.3239 16.5973 31.4486 16.0295 31.4486C15.4559 31.4486 14.9412 31.3239 14.4852 31.0744C14.0292 30.822 13.6693 30.455 13.4055 29.9732C13.1417 29.4914 13.0098 28.9164 13.0098 28.2483C13.0098 27.5772 13.1417 27.0008 13.4055 26.519C13.6693 26.0373 14.0292 25.6716 14.4852 25.4221C14.9412 25.1727 15.4559 25.0479 16.0295 25.0479C16.5973 25.0479 17.1091 25.1727 17.5651 25.4221C18.0211 25.6716 18.381 26.0373 18.6448 26.519C18.9086 27.0008 19.0405 27.5772 19.0405 28.2483ZM14.696 28.2483C14.696 28.8189 14.8107 29.2563 15.0401 29.5602C15.2695 29.8642 15.5993 30.0176 16.0295 30.0205C16.4567 30.0176 16.7851 29.8642 17.0145 29.5602C17.2439 29.2563 17.3572 28.8189 17.3543 28.2483C17.3572 27.6747 17.2439 27.236 17.0145 26.932C16.7851 26.628 16.4567 26.476 16.0295 26.476C15.5993 26.476 15.2695 26.628 15.0401 26.932C14.8107 27.236 14.696 27.6747 14.696 28.2483Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.6644 25.1339H22.3142C22.773 25.1339 23.1759 25.2257 23.5229 25.4092C23.8728 25.5899 24.1424 25.8451 24.3316 26.1749C24.5238 26.5047 24.6198 26.8861 24.6198 27.3191C24.6198 27.7579 24.5223 28.1422 24.3273 28.4719C24.1323 28.7989 23.857 29.0498 23.5014 29.2247C23.1458 29.3996 22.7329 29.4871 22.2626 29.4871H21.299V31.3626H19.6644V25.1339ZM21.9357 28.2139C22.2425 28.211 22.482 28.1307 22.654 27.973C22.8261 27.8124 22.9107 27.5944 22.9078 27.3191C22.9107 27.0467 22.8261 26.8331 22.654 26.6782C22.482 26.5233 22.2425 26.4445 21.9357 26.4416H21.299V28.2139H21.9357Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M25.0889 25.1339H29.5367V26.4588H26.7235V27.5858H29.3044V28.9107H26.7235V30.0377H29.5281V31.3626H25.0889V25.1339Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M35.5805 31.3626H34.2126L31.8984 27.9988H31.8554V31.3626H30.2208V25.1339H31.6145L33.8943 28.4806H33.9459V25.1339H35.5805V31.3626Z",
                    fill: "white"
                })
            ]
        });
    }
    if (props.isHover) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "49",
            height: "49",
            viewBox: "0 0 49 49",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "24.4492",
                    cy: "24.4",
                    r: "19",
                    fill: "#0064FF"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z",
                    fill: "white"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "49",
        height: "49",
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M46.4492 24.4C46.4492 36.5503 36.5995 46.4 24.4492 46.4C12.299 46.4 2.44922 36.5503 2.44922 24.4C2.44922 12.2498 12.299 2.40002 24.4492 2.40002C36.5995 2.40002 46.4492 12.2498 46.4492 24.4Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.4492 45.4C36.0472 45.4 45.4492 35.998 45.4492 24.4C45.4492 12.802 36.0472 3.40002 24.4492 3.40002C12.8512 3.40002 3.44922 12.802 3.44922 24.4C3.44922 35.998 12.8512 45.4 24.4492 45.4ZM24.4492 46.4C36.5995 46.4 46.4492 36.5503 46.4492 24.4C46.4492 12.2498 36.5995 2.40002 24.4492 2.40002C12.299 2.40002 2.44922 12.2498 2.44922 24.4C2.44922 36.5503 12.299 46.4 24.4492 46.4Z",
                fill: "#E2E2E2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "24.4492",
                cy: "24.4",
                r: "19",
                fill: "#555555"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z",
                fill: "white"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (MarkerIcon);


/***/ }),

/***/ 2463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ getBldEmoji; },
/* harmony export */   "DO": function() { return /* binding */ getAgntEmoji; },
/* harmony export */   "zM": function() { return /* binding */ getGdsEmoji; }
/* harmony export */ });
var getGdsEmoji = function(code) {
    switch(code){
        case "LUXURY_DESIGN":
            return "✨";
        case "VARIOUS_PRODUCTS_SELECTION":
            return "\uD83D\uDECD️";
        case "ECO_FRIENDLY_MATERIALS":
            return "\uD83C\uDF3F";
        case "REASONABLE_PRICE_QUALITY":
            return "\uD83D\uDCB0";
        case "IN_STORE_PRODUCT_VIEWING":
            return "\uD83D\uDC40";
        default:
            return "";
    }
};
var getBldEmoji = function(code) {
    switch(code){
        case "PROFESSIONAL_INSTALLATION":
            return "\uD83D\uDC4D";
        case "ATTENTION_TO_DETAIL":
            return "\uD83E\uDDD0";
        case "FLEXIBLE_SCHEDULING":
            return "\uD83D\uDDD3️";
        case "CLEAN_FINISH":
            return "\uD83E\uDDF9";
        case "AFTER_SALE_SUPPORT":
            return "\uD83E\uDDF0";
        default:
            return "";
    }
};
var getAgntEmoji = function(code) {
    switch(code){
        case "PROFESSIONAL":
            return "\uD83D\uDC68‍\uD83D\uDCBB";
        case "RESOLVING":
            return "\uD83E\uDD13";
        case "PREVIEW":
            return "\uD83D\uDC40";
        case "CUSTOMIZED":
            return "✏️";
        case "TRUSTWORTHY":
            return "\uD83D\uDE0C";
        default:
            return "";
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,8974,9046,3851,378,4945,1892,2141,3651,5262,9774,2888,179], function() { return __webpack_exec__(2439); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);